/* AUTO-GENERATED from popup/*.js by scripts/build-popup-widget.mjs.
   Do NOT edit here; edit the source and rebuild (npm run build:popup). Include via
   snippets/szn-popup-widget.liquid. Config: window.SZN_POPUP_API (API base),
   window.SZN_POPUP_CONFIG (embedUrls / quizUrl). */
(function(){
"use strict";
// Pure popup model helpers, self-contained for the STOREFRONT widget bundle
// (card 41). Mirrors the deep-merge + variant resolution in api/popups-model.js /
// api/popups-generic.js, but WITHOUT importing them: those pull in `pg` (server
// code) and must never end up in the browser asset. The build concatenates only
// popup/*.js, so the widget carries its own copy of this tiny pure logic.
//
// Same semantics as the server: `over` wins, arrays replace wholesale (so a
// variant can swap the whole elements[] — e.g. quiz→plinko), neither input
// mutated, unknown/missing variant key returns the base unchanged.

const PRESENTATION_TYPES = new Set(["takeover", "slide-in", "bar"]);
const FALLBACK_TYPE = "takeover";

function isPlainObject(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}

// Recursive deep-merge of plain objects. Arrays and scalars replace wholesale.
function deepMerge(base, over) {
  if (!isPlainObject(over)) return over === undefined ? base : over;
  const out = isPlainObject(base) ? { ...base } : {};
  for (const k of Object.keys(over)) {
    out[k] = isPlainObject(over[k]) && isPlainObject(out[k])
      ? deepMerge(out[k], over[k])
      : over[k];
  }
  return out;
}

// Resolve a named variant's effective popup: base deep-merged with the matching
// variant's `config` overrides. Unknown/missing key or non-array variants →
// returns the base popup unchanged (documented fallback, never throws).
function resolvePopupVariant(popup, key) {
  const base = popup || {};
  const variants = base.variants;
  if (!key || !Array.isArray(variants)) return base;
  const match = variants.find((v) => v && v.key === key);
  if (!match || !isPlainObject(match.config)) return base;
  return deepMerge(base, match.config);
}

// Behavioral mapping for the storefront widget: known presentation formats pass
// through; legacy/unknown stored values behave as the takeover format.
function normalizeType(type) {
  return PRESENTATION_TYPES.has(type) ? type : FALLBACK_TYPE;
}

// PURE eligibility logic for the storefront popup widget (card 41). Given a popup
// doc + a runtime context (audience/page/device/source, now) + a per-popup show
// record, decide two things independently:
//   - targetingMatch(popup, ctx)  — does this visit match the popup's targeting?
//   - frequencyAllows(popup, record, now) — has this popup been shown too recently?
//     (an empty/unset frequency DEFAULTS to once-per-session, not unlimited — card 89.)
// `isEligible` also hard-blocks a CONVERTED popup (record.converted === true) — a
// won/claimed offer ends that popup's lifecycle regardless of targeting/frequency.
// No DOM, no localStorage, no globals here — the record + now are passed in — so
// this file is fully unit-testable under `node --test`.
//
// Targeting is read GENERICALLY off the registry-driven axes (audience/pages/
// device/source): each axis value in the doc may be a scalar or an array; "all"
// is a wildcard; an axis the doc omits is unconstrained; an axis the runtime ctx
// doesn't provide is skipped (forward-compat — a NEW axis added to the model must
// not hard-block an old widget). `rules[]` is an optional extra allow/deny list.

function toArray(v) {
  if (v === undefined || v === null) return [];
  return Array.isArray(v) ? v : [v];
}

// A single axis matches when the doc allows "all", is empty/unconstrained, or the
// ctx value is one of the allowed values.
function axisMatches(allowed, ctxValue) {
  const list = toArray(allowed);
  if (list.length === 0) return true;         // unconstrained
  if (list.includes("all")) return true;      // explicit wildcard
  if (ctxValue === undefined || ctxValue === null) return true; // ctx silent → skip
  return list.includes(ctxValue);
}

// The runtime-supplied targeting axes we know how to map. Adding a new axis to
// the model + ctx is picked up automatically; an axis present in the doc but not
// listed here (unknown/newer) is IGNORED (forward-compat), never a hard block.
const KNOWN_AXES = ["audience", "pages", "device", "source"];

// Map each known targeting axis to the ctx field it reads. `pages` reads ctx.page.
function ctxValueFor(axis, ctx) {
  if (axis === "pages") return ctx.page;
  return ctx[axis];
}

// Evaluate optional rules[]: [{ axis, op:"is"|"not", value }]. A "not" rule that
// matches DENIES; an "is" rule that fails to match DENIES. Unknown ops are ignored.
function rulesAllow(rules, ctx) {
  if (!Array.isArray(rules)) return true;
  for (const rule of rules) {
    if (!rule || typeof rule.axis !== "string") continue;
    const ctxValue = ctxValueFor(rule.axis, ctx);
    const values = toArray(rule.value);
    const hit = ctxValue !== undefined && ctxValue !== null && values.includes(ctxValue);
    if (rule.op === "not" && hit) return false;
    if ((rule.op === "is" || rule.op === undefined) && values.length > 0 && !hit) return false;
  }
  return true;
}

// Does this visit match the popup's targeting? Missing targeting → matches (show
// everywhere). Reads only KNOWN_AXES + rules[]; unknown axes are ignored.
function targetingMatch(popup, ctx = {}) {
  const targeting = (popup && popup.targeting) || {};
  for (const axis of KNOWN_AXES) {
    if (!Object.prototype.hasOwnProperty.call(targeting, axis)) continue;
    if (!axisMatches(targeting[axis], ctxValueFor(axis, ctx))) return false;
  }
  return rulesAllow(targeting.rules, ctx);
}

// Is the frequency object entirely empty/unset — no rule, no numeric cooldownDays,
// no numeric maxShows? Such a config gets the safe default (once-per-session);
// any explicitly-configured field means "use the config verbatim".
function frequencyIsEmpty(freq) {
  return !freq.rule
    && typeof freq.cooldownDays !== "number"
    && typeof freq.maxShows !== "number";
}

// Frequency gate. `record` is this popup's show history from the frequency store:
// { count, lastShownAt (ms epoch), session (bool: shown this session) }. `now` is
// ms epoch. Reads the popup's `frequency` object generically:
//   rule: "once-per-session" (default) — blocks a 2nd show in the same session
//   cooldownDays — blocks within N days of the last show
//   maxShows — caps total lifetime shows
// An empty/unset frequency object DEFAULTS to once-per-session (not unlimited): a
// popup with no frequency config shows at most once per browser session. An
// explicitly-configured frequency is used verbatim (unchanged behavior).
function frequencyAllows(popup, record = {}, now = Date.now()) {
  const freq = (popup && popup.frequency) || {};
  const count = typeof record.count === "number" ? record.count : 0;
  const rule = frequencyIsEmpty(freq) ? "once-per-session" : freq.rule;

  if (typeof freq.maxShows === "number" && count >= freq.maxShows) return false;

  if (rule === "once-per-session" && record.session === true) return false;

  if (typeof freq.cooldownDays === "number" && freq.cooldownDays > 0
    && typeof record.lastShownAt === "number") {
    const windowMs = freq.cooldownDays * 24 * 60 * 60 * 1000;
    if (now - record.lastShownAt < windowMs) return false;
  }

  return true;
}

// Combined gate: a CONVERTED popup is never eligible (its lifecycle ended when the
// visitor won/claimed its offer — card 89), independent of targeting/frequency.
// Otherwise: targeting AND frequency. Convenience for the orchestrator.
function isEligible(popup, ctx, record, now) {
  if (record && record.converted === true) return false;
  return targetingMatch(popup, ctx) && frequencyAllows(popup, record, now);
}

// Per-popup show records for the storefront widget (card 41). Client-only,
// non-PII: a DURABLE map of { [popupId]: { count, lastShownAt } } persisted in
// localStorage under `szn_popup_shows` (drives cooldown-days + max-shows), plus a
// PER-SESSION set of ids in sessionStorage under `szn_popup_session` (drives
// once-per-session — resets on a new tab/session). The orchestrator merges the
// session flag onto the durable record before calling frequencyAllows.
//
// Both storages are INJECTABLE (default to the window globals) so this is testable
// under `node --test` with fakes, and every access is try/catch-wrapped so a
// blocked/absent storage never throws into the widget.

const KEY = "szn_popup_shows";
const SESSION_KEY = "szn_popup_session";

function defaultStorage() {
  try {
    if (typeof localStorage !== "undefined") return localStorage;
  } catch { /* access can throw in sandboxed frames */ }
  return null;
}

function defaultSession() {
  try {
    if (typeof sessionStorage !== "undefined") return sessionStorage;
  } catch { /* access can throw in sandboxed frames */ }
  return null;
}

// Has this popup been shown in THIS browser session (tab lifetime)?
function seenThisSession(id, session = defaultSession()) {
  if (!session) return false;
  try {
    const raw = session.getItem(SESSION_KEY);
    if (!raw) return false;
    const set = JSON.parse(raw);
    return Array.isArray(set) && set.includes(id);
  } catch {
    return false;
  }
}

// Mark this popup as shown in the current session.
function markSession(id, session = defaultSession()) {
  if (!session) return;
  try {
    const raw = session.getItem(SESSION_KEY);
    let set = [];
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) set = parsed;
    }
    if (!set.includes(id)) set.push(id);
    session.setItem(SESSION_KEY, JSON.stringify(set));
  } catch { /* private mode — session gate just won't persist */ }
}

// Read the whole show map. Returns {} on any failure (absent/blocked/corrupt).
function readAll(storage = defaultStorage()) {
  if (!storage) return {};
  try {
    const raw = storage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

// The record for one popup, or an empty record if none.
function getRecord(id, storage = defaultStorage()) {
  const all = readAll(storage);
  const rec = all[id];
  return rec && typeof rec === "object" ? rec : { count: 0 };
}

// Persist the whole map. Swallows quota/blocked errors.
function writeAll(all, storage) {
  if (!storage) return;
  try {
    storage.setItem(KEY, JSON.stringify(all));
  } catch { /* quota / private mode — frequency just won't persist */ }
}

// The record `frequencyAllows` expects: the durable count/lastShownAt PLUS the
// live per-session flag. Merges the two storages so eligibility sees one shape.
function eligibilityRecord(id, storage = defaultStorage(), session = defaultSession()) {
  const rec = getRecord(id, storage);
  return { ...rec, session: seenThisSession(id, session) };
}

// Record one show of `id` at `now` (ms epoch): bump durable count + stamp
// lastShownAt, and mark session-seen. Returns the updated durable record.
function recordShow(id, now = Date.now(), storage = defaultStorage(), session = defaultSession()) {
  const all = readAll(storage);
  const prev = (all[id] && typeof all[id] === "object") ? all[id] : { count: 0 };
  const next = {
    count: (typeof prev.count === "number" ? prev.count : 0) + 1,
    lastShownAt: now,
  };
  all[id] = next;
  writeAll(all, storage);
  markSession(id, session);
  return next;
}

// Clear every popup's show record (QA / reset).
function clearAll(storage = defaultStorage(), session = defaultSession()) {
  if (storage) {
    try { storage.removeItem(KEY); } catch { /* ignore */ }
  }
  if (session) {
    try { session.removeItem(SESSION_KEY); } catch { /* ignore */ }
  }
}

// PURE A/B variant selection for the storefront popup widget (card 41). If the
// popup carries a `posthogFlagKey`, ask a flag-reader for the assigned variant and
// resolve that variant's overrides via resolvePopupVariant (a variant may replace
// the whole elements[]); otherwise use the base popup. NO PostHog import here — the
// flag reader is injected (defaults wired by the widget to window.posthog), so this
// runs under `node --test` and is fail-safe: any thrown / missing / unknown flag
// falls back to the base popup.


// Read the PostHog-assigned variant string for a flag, never throwing. Returns
// undefined when there is no reader, no flag, or the reader errors.
function readFlag(flagReader, flagKey) {
  if (typeof flagReader !== "function" || !flagKey) return undefined;
  try {
    const v = flagReader(flagKey);
    return typeof v === "string" && v ? v : undefined;
  } catch {
    return undefined;
  }
}

// Pick the effective popup + the variant key that produced it.
//   pickVariant(popup, flagReader) -> { variantKey, resolved }
// - no flag key on the popup           → { variantKey: null, resolved: base }
// - flag key but reader silent/throws  → { variantKey: null, resolved: base }
// - flag returns a key                 → { variantKey: key, resolved: merged }
//   (an unknown key resolves to base via resolvePopupVariant's fallback, but the
//    key is still reported so exposure is attributed to what PostHog assigned)
function pickVariant(popup, flagReader) {
  const base = popup || {};
  const flagKey = base.posthogFlagKey;
  const assigned = readFlag(flagReader, flagKey);
  if (!assigned) return { variantKey: null, resolved: base };
  return { variantKey: assigned, resolved: resolvePopupVariant(base, assigned) };
}

// PURE event payload builders + a no-op-safe reporter for the storefront popup
// widget (card 41). Every event is keyed to the popup id + the selected variant so
// PostHog can attribute exposures and conversions. Mirrors analytics.js discipline:
// the `capture` fn is injectable (defaults to window.posthog?.capture) and every
// call is try/catch-wrapped, so analytics being absent never breaks the widget.
//
// Exposure uses PostHog's canonical `$feature_flag_called` event (records which
// flag/variant a user was bucketed into). Conversion events are the popup funnel:
// popup_opened → popup_engaged → popup_email_captured / popup_offer_claimed /
// popup_closed.

const EXPOSURE_EVENT = "$feature_flag_called";

const CONVERSION_EVENTS = Object.freeze({
  opened: "popup_opened",
  engaged: "popup_engaged",
  email: "popup_email_captured",
  offer: "popup_offer_claimed",
  closed: "popup_closed",
});

// Common properties on every popup event: which popup + variant.
function baseProps(popup, variantKey, extra = {}) {
  return {
    popup_id: (popup && popup.id) || null,
    popup_variant: variantKey || null,
    ...extra,
  };
}

// PostHog exposure payload: ties the user to the flag + assigned variant. Uses
// PostHog's documented $feature_flag / $feature_flag_response property names so it
// lines up with native flag reporting.
function exposurePayload(popup, variantKey) {
  return {
    $feature_flag: (popup && popup.posthogFlagKey) || null,
    $feature_flag_response: variantKey || null,
    ...baseProps(popup, variantKey),
  };
}

// Resolve the default capture fn from the browser (no-op when absent).
function defaultCapture() {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      return window.posthog.capture.bind(window.posthog);
    }
  } catch { /* ignore */ }
  return null;
}

// Fire an arbitrary event, no-op safe.
function fire(capture, event, payload) {
  const fn = typeof capture === "function" ? capture : defaultCapture();
  if (!fn) return;
  try { fn(event, payload); } catch { /* analytics must never break the widget */ }
}

// A reporter bound to one popup + variant. `capture` is injectable; when omitted
// it lazily resolves window.posthog.capture at fire time.
function makeReporter(popup, variantKey, capture) {
  return {
    exposure() {
      fire(capture, EXPOSURE_EVENT, exposurePayload(popup, variantKey));
    },
    conversion(kind, extra = {}) {
      const event = CONVERSION_EVENTS[kind];
      if (!event) return;
      fire(capture, event, baseProps(popup, variantKey, extra));
    },
  };
}

// Trigger scheduling for the storefront popup widget (card 41). Maps a popup's
// `trigger.kind` (registry: delay-after-load / scroll / exit-intent / immediate /
// load-scroll) to WHEN the popup should fire. The scheduling logic is PURE over an
// injected `hooks` bag so it runs under `node --test` with no DOM: the widget wires
// the real window/document hooks; tests wire fakes and drive the callbacks manually.
//
// hooks = {
//   onLoad(cb)          register a page-load callback (fires cb once the page is loaded)
//   addScroll(cb)       register a scroll listener; cb() called on each scroll, reads percent
//   addScrollIntent(cb) register a scroll/wheel/touchmove listener; cb() on first intent
//   scrollPercent()     current scroll depth 0..100
//   addExit(cb)         register a mouseleave-top (exit-intent) listener
//   setTimeout(cb,ms)   schedule cb after ms
// }
// scheduleTrigger returns a `cancel()` that removes whatever it registered (so the
// orchestrator can tear a trigger down after it fires once).

// Fire `fire` at most once, and return the guarded wrapper.
function once(fire) {
  let done = false;
  return () => {
    if (done) return;
    done = true;
    fire();
  };
}

function num(v, dflt) {
  return typeof v === "number" && isFinite(v) ? v : dflt;
}

// Schedule `fire` per the trigger. Returns { cancel }.
//   delay-after-load: run onLoad, then setTimeout(seconds*1000) — the delay is
//                     counted FROM the load event, not from injection.
//   scroll:           fire when scrollPercent() >= params.percent.
//   exit-intent:      fire on the first top mouseleave.
//   load-scroll:      run onLoad, then setTimeout(delay_s*1000); once the delay
//                     elapses, arm a scroll-intent listener (scroll/wheel/touchmove)
//                     and fire on the FIRST intent. Scrolls before the delay (or
//                     before load) do not count. Falls back to addScroll if
//                     addScrollIntent is absent.
//   immediate:        fire synchronously now.
//   unknown kind:     treated as immediate (fail-open to showing) — but the widget
//                     only reaches here for eligible popups, so this is safe.
function scheduleTrigger(kind, params = {}, hooks = {}, fire = () => {}) {
  const fireOnce = once(fire);
  const cleanups = [];
  const cancel = () => { while (cleanups.length) { try { cleanups.pop()(); } catch { /* ignore */ } } };

  if (kind === "immediate") {
    fireOnce();
    return { cancel };
  }

  if (kind === "delay-after-load") {
    const ms = num(params.seconds, 0) * 1000;
    const off = hooks.onLoad && hooks.onLoad(() => {
      const t = hooks.setTimeout && hooks.setTimeout(() => { fireOnce(); cancel(); }, ms);
      if (t !== undefined) cleanups.push(() => hooks.clearTimeout && hooks.clearTimeout(t));
    });
    if (off) cleanups.push(off);
    return { cancel };
  }

  if (kind === "scroll") {
    const target = num(params.percent, 50);
    const off = hooks.addScroll && hooks.addScroll(() => {
      const pct = hooks.scrollPercent ? hooks.scrollPercent() : 0;
      if (pct >= target) { fireOnce(); cancel(); }
    });
    if (off) cleanups.push(off);
    return { cancel };
  }

  if (kind === "exit-intent") {
    const off = hooks.addExit && hooks.addExit(() => { fireOnce(); cancel(); });
    if (off) cleanups.push(off);
    return { cancel };
  }

  if (kind === "load-scroll") {
    const ms = num(params.delay_s, 0) * 1000;
    const armIntent = hooks.addScrollIntent || hooks.addScroll;
    const arm = () => {
      const unbind = armIntent && armIntent(() => { fireOnce(); cancel(); });
      if (unbind) cleanups.push(unbind);
    };
    const off = hooks.onLoad && hooks.onLoad(() => {
      if (ms <= 0) { arm(); return; }
      const t = hooks.setTimeout && hooks.setTimeout(arm, ms);
      if (t !== undefined) cleanups.push(() => hooks.clearTimeout && hooks.clearTimeout(t));
    });
    if (off) cleanups.push(off);
    return { cancel };
  }

  // Unknown/absent kind → show immediately (eligibility already passed).
  fireOnce();
  return { cancel };
}

// PURE CTA resolution for the storefront popup widget (card 41). A button/CTA
// element carries `props.action` (+ supporting props). This turns that into a
// side-effect-free DESCRIPTOR the render layer executes — so navigation / discount
// application / close logic stays out of the pure model layer and is unit-testable.
//
// Actions (registry element `button` props: label/href/action):
//   "quiz"           → open the quiz (descriptor kind:"navigate", url from props.href or config)
//   "product"        → go to a product URL (props.href / props.url)
//   "close"          → dismiss the popup (kind:"close"), optionally applying a discount code
//   "apply-code"     → close + apply a discount code (kind:"close", code set)
//   "url"/custom     → navigate to props.href
// Unknown/absent action with an href → navigate; with nothing → safe close.
//
// Only http/https (and root-relative "/") URLs survive; anything else (javascript:,
// data:) is dropped to null so the render layer never navigates to a hostile scheme.

// Allow only http(s) absolute URLs or root-relative paths. Returns null otherwise.
function safeUrl(raw) {
  if (typeof raw !== "string" || raw === "") return null;
  const s = raw.trim();
  if (s.startsWith("/") && !s.startsWith("//")) return s; // root-relative
  try {
    const u = new URL(s);
    return (u.protocol === "http:" || u.protocol === "https:") ? s : null;
  } catch {
    return null;
  }
}

function pickUrl(props, config) {
  return safeUrl(props.href) || safeUrl(props.url)
    || safeUrl(config && config.quizUrl) || null;
}

function code(props) {
  return typeof props.code === "string" && props.code ? props.code : null;
}

// Resolve a CTA element's props (+ optional widget config) to a descriptor:
//   { kind: "navigate", url }              — the render layer sets location
//   { kind: "close", code }                — dismiss; code may be applied at checkout
// `code` is passed through on every descriptor so a "navigate + discount" CTA works.
function resolveCta(props = {}, config = {}) {
  const action = typeof props.action === "string" ? props.action : "";
  const discount = code(props);

  if (action === "close") {
    return { kind: "close", code: discount };
  }
  if (action === "apply-code") {
    return { kind: "close", code: discount };
  }
  if (action === "quiz") {
    const url = safeUrl(props.href) || safeUrl(config.quizUrl);
    return url ? { kind: "navigate", url, code: discount } : { kind: "close", code: discount };
  }
  if (action === "product" || action === "url" || action === "") {
    const url = pickUrl(props, config);
    return url ? { kind: "navigate", url, code: discount } : { kind: "close", code: discount };
  }
  // Unknown action: navigate if we have a safe URL, else close.
  const url = pickUrl(props, config);
  return url ? { kind: "navigate", url, code: discount } : { kind: "close", code: discount };
}

// Resolve a popup's model-level `config.destination` to the SAME descriptor shape as
// resolveCta (card 73). This is the canonical completion destination the dashboard
// writes onto a popup, so a quiz/plinko win with NO button element still has somewhere
// to go. Shape: { kind:"quiz"|"product"|"close-apply"|"custom", url, discount_code }.
//   quiz/product/custom → navigate to a safe url (else null → caller falls through)
//   close-apply         → close, applying discount_code
// Returns null when the destination is absent or too malformed to act on, so the
// caller can fall back to button props / legacy config without a hard-coded guess.
// (The legacy model default is {url, utm}; a bare `url` with no `kind` is honored as a
// navigate so old-shape destinations still work.)
function resolveDestination(destination, config = {}) {
  if (!destination || typeof destination !== "object") return null;
  const kind = typeof destination.kind === "string" ? destination.kind : "";
  const discount = typeof destination.discount_code === "string" && destination.discount_code
    ? destination.discount_code : null;

  if (kind === "close-apply") return { kind: "close", code: discount };

  // quiz falls back to config.quizUrl when the destination omits a url.
  const url = kind === "quiz"
    ? (safeUrl(destination.url) || safeUrl(config.quizUrl))
    : safeUrl(destination.url);
  if (url) return { kind: "navigate", url, code: discount };

  // No safe url: an explicit destination kind still means "act" → close (apply code
  // if any); a shapeless destination (no kind, no url) → null so the caller falls
  // through to button props / legacy config.
  if (kind === "quiz" || kind === "product" || kind === "custom") {
    return { kind: "close", code: discount };
  }
  return null;
}

// The `embed` element kind for the storefront popup widget (card 41). An embed
// mounts a mini-experience in an iframe and speaks a postMessage contract with it:
//   quiz   → iframe to the quiz origin (reuses the existing {source:"szn-quiz"} channel)
//   plinko → iframe to the Plinko game URL; win/close messages drive discount + close
// The game URL is MODEL-DRIVEN (props.url / widget config) — nothing hard-coded — with
// a documented placeholder default so the card ships without inventing a real URL.
//
// SECURITY BOUNDARY: cross-frame input is untrusted. `handleEmbedMessage` is a PURE
// function (no DOM) that verifies BOTH event.origin (against the embed's own origin)
// AND data.source before returning an action descriptor — tested without a browser.
//   valid {source:"szn-plinko", type:"win", code, discount} → { kind:"win", code, discount }
//   valid {source:"szn-plinko", type:"close"}               → { kind:"close" }
//   wrong origin / wrong source / unknown type              → null (ignored)



const PLINKO_SOURCE = "szn-plinko";
const QUIZ_SOURCE = "szn-quiz";

// Documented placeholder — the real URLs come from the model (embed props.url) or
// widget config. Never hard-code a production URL here.
const DEFAULT_EMBED_URLS = Object.freeze({
  quiz: "https://quiz.sznpouches.com/",
  plinko: "https://quiz.sznpouches.com/plinko/",
});

const STORE_NAVIGATE_ORIGINS = Object.freeze(["https://sznpouches.com"]);

// Per-source ALLOWLIST of element props that may be forwarded to the iframe as
// query params (card 67). This is the isolation control: only these keys can ever
// reach the embedded experience's URL — arbitrary / attacker-supplied prop keys
// (incl. prototype-pollution-style keys) can NEVER be forwarded. Per-source and
// extensible; nothing is hard-coded per popup. Keyed on the CONFIG-KEY source value
// ("quiz" / "plinko"), NOT the postMessage source (szn-quiz / szn-plinko).
const EMBED_QUERY_WHITELIST = Object.freeze({
  quiz: Object.freeze([
    "kicker", "headline", "sub", "ctaText", "ctaHref", "hint",
    "code", "discount", "label", "winLabel", "win_pct", "bg",
  ]),
  plinko: Object.freeze([
    "kicker", "headline", "sub", "ctaText", "ctaHref", "hint",
    "code", "discount", "label", "winLabel", "win_pct", "bg",
    // Success/prize copy the dashboard editor writes onto plinko embeds (card 71).
    // `prize` is the embed's alias of `label`; the embed side resolves the alias.
    "successHeadline", "successSub", "claimText", "prize",
  ]),
});

// Pure helper: append the source's whitelisted props onto a URL's search params.
// A prop is forwarded ONLY when its value is a non-empty string or a number, and
// ONLY when the URL does not already carry that key (merge into a model-provided
// query, never clobber it). Values are serialized via URLSearchParams so they are
// URL-encoded — no query injection. Numbers serialize decimally (win_pct=40, not 4e1).
function appendWhitelistedProps(u, props, source) {
  const keys = EMBED_QUERY_WHITELIST[source];
  if (!Array.isArray(keys) || !props) return u;
  for (const key of keys) {
    if (u.searchParams.has(key)) continue; // don't clobber an existing query param
    const value = props[key];
    const isNonEmptyString = typeof value === "string" && value !== "";
    const isNumber = typeof value === "number" && Number.isFinite(value);
    if (!isNonEmptyString && !isNumber) continue; // skip empty / non-scalar
    u.searchParams.set(key, String(value));
  }
  return u;
}

// Compute the iframe URL for an embed element from its props + widget config,
// falling back to the documented default per source. Only http/https survive.
// For the QUIZ source, auto-append ?embed=1 to the selected base URL so the
// funnel boots in compact in-popup mode. props.url/config still override the base
// URL; an existing embed param remains authoritative. Finally the source's
// WHITELISTED content props are merged in as query params (card 67).
//
// Every code path funnels through the SAME `u` (URL) and the single `return u.href`
// exit, so the param merge applies uniformly — no early `return raw` can drop it.
function embedUrl(props = {}, config = {}) {
  const source = typeof props.source === "string" ? props.source : "";
  const explicit = typeof props.url === "string" && props.url;
  const configured = (config.embedUrls && config.embedUrls[source]) || DEFAULT_EMBED_URLS[source];
  const raw = explicit ? props.url : configured;
  if (typeof raw !== "string") return null;
  try {
    const u = new URL(raw);
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    // Merge, don't clobber: an explicit embed=0/debug value is respected.
    if (source === "quiz" && !u.searchParams.has("embed")) {
      u.searchParams.set("embed", "1");
    }
    // Bare-chrome popup embed (card 97): the quiz drops its intro hero can and renders
    // over a transparent background inside the popup. Only when embed is actually ON
    // (an explicit embed=0 debug opt-out stays fully standalone). Merge, don't clobber —
    // an explicit chrome=... on the model URL stays authoritative.
    if (source === "quiz" && !u.searchParams.has("chrome")) {
      const embedFlag = u.searchParams.get("embed");
      if (embedFlag != null && embedFlag !== "" && embedFlag !== "0") {
        u.searchParams.set("chrome", "bare");
      }
    }
    appendWhitelistedProps(u, props, source);
    return u.href;
  } catch {
    return null;
  }
}

// The origin an embed's messages must come from (used to verify event.origin).
function embedOrigin(props, config) {
  const url = embedUrl(props, config);
  if (!url) return null;
  try { return new URL(url).origin; } catch { return null; }
}

function safeEmbedNavigateUrl(raw, expectedOrigin) {
  const url = safeUrl(raw);
  if (!url) return null;
  if (url.startsWith("/")) return url;
  try {
    const origin = new URL(url).origin;
    if (origin === expectedOrigin || STORE_NAVIGATE_ORIGINS.includes(origin)) return url;
  } catch { /* safeUrl already parsed; keep this defensive */ }
  return null;
}

// PURE message handler. `event` = { origin, data }. `expectedOrigin` = the embed's
// own origin. Returns an action descriptor or null (ignored). Verifies origin AND
// source before trusting anything.
function handleEmbedMessage(event, expectedOrigin) {
  if (!event || typeof event !== "object") return null;
  if (!expectedOrigin || event.origin !== expectedOrigin) return null;
  const data = event.data;
  if (!data || typeof data !== "object") return null;

  if (data.source === PLINKO_SOURCE) {
    if (data.type === "win") {
      return {
        kind: "win",
        code: typeof data.code === "string" ? data.code : null,
        discount: data.discount != null ? data.discount : null,
      };
    }
    if (data.type === "close") return { kind: "close" };
    return null;
  }

  // Quiz channel (card 47/73): the funnel posts complete/navigate/close/engaged over
  // the same {source:"szn-quiz"} channel it already uses for `step`.
  //   coded complete   → win/apply descriptor (plinko parity)
  //   codeless complete → `complete` — a NON-closing signal; the popup logs the
  //                       conversion and keeps the result panel OPEN (card 73 item 1)
  //   navigate {url}    → `navigate` ONLY when url is root-relative or belongs to
  //                       the verified quiz origin / live store origin.
  //                       Hostile origins / schemes / missing url → null (ignored).
  //                       This is the checkout/CTA handoff routed through the top
  //                       window instead of loading the PDP inside the iframe (item 3).
  if (data.source === QUIZ_SOURCE) {
    if (data.type === "complete") {
      if (typeof data.code !== "string" || !data.code) return { kind: "complete" };
      return {
        kind: "win",
        code: data.code,
        discount: data.discount != null ? data.discount : null,
      };
    }
    if (data.type === "navigate") {
      const url = safeEmbedNavigateUrl(data.url, expectedOrigin);
      return url ? { kind: "navigate", url } : null;
    }
    if (data.type === "close") return { kind: "close" };
    if (data.type === "engaged") return { kind: "engaged" };
    // Step broadcast (card 113): the funnel already posts its current step on every
    // render (incl. the result, and on Back). Surface it so the popup can WIDEN the
    // quiz embed for the result step and revert on any earlier step. Non-secret display
    // state only (a step type string) — no answers/PII.
    if (data.type === "step") {
      return { kind: "step", stepType: typeof data.stepType === "string" ? data.stepType : null };
    }
    return null; // unknown types are display-only, not actions
  }

  return null;
}

// --- DOM mount (browser-only glue) -------------------------------------------

// The iframe height when the embed is NOT positioned by a percent `h` (standalone /
// non-takeover contexts): the authored px, else a sensible default box. When the
// element IS positioned by percent `h`, the caller passes `fillParent:true` and the
// iframe fills its positioned wrapper (`height:100%`) so the percent maps to the
// screen instead of clamping the stage to a fixed 480px box (card 60).
function embedFrameHeight(props, fillParent) {
  if (fillParent) return "100%";
  return typeof props.height === "number" ? props.height + "px" : "480px";
}

// Build the iframe node for an embed + wire an origin-checked message listener.
// `onAction(descriptor)` is called with the result of handleEmbedMessage for
// plinko win/close. `deps` injects document/window for testing the wiring; in the
// browser they default to the globals. `deps.fillParent` makes the iframe fill its
// positioned wrapper (percent `h` case) rather than impose the authored/fallback px.
// Returns the iframe node (or null if the URL is unsafe — a hostile/missing url
// renders nothing rather than a bad frame).
function mountEmbed(props, config, onAction, deps = {}) {
  const doc = deps.document || (typeof document !== "undefined" ? document : null);
  const win = deps.window || (typeof window !== "undefined" ? window : null);
  if (!doc) return null;
  const url = embedUrl(props, config);
  if (!url) return null;
  const origin = embedOrigin(props, config);

  const frame = doc.createElement("iframe");
  frame.setAttribute("src", url);
  frame.setAttribute("title", props.source === "plinko" ? "Plinko" : "Quiz");
  frame.style.border = "0";
  frame.style.width = "100%";
  frame.style.height = embedFrameHeight(props, deps.fillParent);
  // Transparent iframe (card 97): the quiz embed renders over the popup's own
  // background, so the frame itself must not impose a white box. `allowtransparency`
  // is the legacy attribute some engines still honor; a transparent funnel document
  // (chrome=bare → --embed-bg transparent) then lets the popup background show through.
  if (props.source === "quiz") {
    frame.style.background = "transparent";
    frame.setAttribute("allowtransparency", "true");
  }

  // Wire the origin-checked message listener for BOTH embed sources — quiz and
  // plinko both speak a postMessage contract (card 47). handleEmbedMessage is the
  // trust boundary (origin + source checked); unknown sources still return null.
  if (win && typeof win.addEventListener === "function" &&
      (props.source === "quiz" || props.source === "plinko")) {
    const listener = (event) => {
      const action = handleEmbedMessage(event, origin);
      if (action && typeof onAction === "function") onAction(action);
    };
    win.addEventListener("message", listener);
    frame._sznCleanup = () => win.removeEventListener("message", listener);
  }
  return frame;
}

const __embedContract = { PLINKO_SOURCE, QUIZ_SOURCE };

// Takeover-only geometry + polish for the storefront popup widget (card 49). ONE
// job: everything that makes a `type: "takeover"` popup render as a 100%
// full-viewport, edge-to-edge, zero-radius, full-bleed Gruns-style takeover — the
// full-screen overlay, the full-viewport element canvas, the pill answer buttons,
// the opening transition, and the on-brand contrast-aware filled close disc.
// Pure DOM styling: the document/window are injected so this is exercised in the
// fake-DOM unit tests with no jsdom. Slide-in/bar/center geometry live in
// render-popup.js and are untouched by this module.
//
// SECURITY BOUNDARY: `style.background` / `style.background_image` come from the
// (untrusted at render time) model doc. `background_image` is routed through the
// shared popupBackgroundImage (safeUrl allow-list + url("...") CSS-context escape)
// before it ever lands on a style declaration, so a full-bleed background cannot
// inject CSS. `style.background` is a plain color string assigned as-is (same as the
// legacy path). Nothing here parses HTML or executes model input.


// Full-bleed overlay: fixed, edge-to-edge, its OWN background carries the full-bleed
// color + image so the element canvas above can stay transparent. Zero
// radius, safe-area padding (no-ops without viewport-fit=cover), internal scroll on
// overflow, centered flex column. Height uses 100dvh with a -webkit-fill-available
// fallback: in the real browser the cascade keeps the last-supported declaration; in
// the fake DOM only the final write is observed, so dvh (the value we intend to win)
// is written last.
function applyTakeoverOverlay(overlay, style) {
  const s = overlay.style;
  s.position = "fixed";
  s.zIndex = "2147483000";
  s.inset = "0";
  s.width = "100%";
  s.height = "-webkit-fill-available"; // fallback first…
  s.height = "100dvh";                 // …modern wins the cascade in real browsers
  s.margin = "0";
  s.borderRadius = "0";
  s.display = "flex";
  s.flexDirection = "column";
  s.alignItems = "center";
  s.justifyContent = "center";
  s.overflow = "auto"; // internal scroll when the authored content overflows
  s.boxSizing = "border-box";
  s.padding =
    "env(safe-area-inset-top) env(safe-area-inset-right) " +
    "env(safe-area-inset-bottom) env(safe-area-inset-left)";
  s.background = popupStyleString(style.background) || "#101010";
  // Full-bleed cover image on the overlay itself (behind the content column). Only
  // set when the authored URL survives the safeUrl allow-list AND the url() escape.
  const bgImage = popupBackgroundImage(style.background_image);
  if (bgImage) {
    s.backgroundImage = bgImage;
    s.backgroundSize = "cover";
    s.backgroundPosition = "center";
  }
}

// The takeover canvas. It must be the full viewport so element percentage coords
// map to the screen, not to a modal/card column. Individual authored elements can
// still constrain their own x/w for a readable desktop column.
//
// The stage fills the flex-column overlay by FLEX GROWTH (`flex: 1 1 auto`), not by
// a percentage-height chain. A pure `height:100%` + `min-height:100%` depends on the
// overlay resolving a definite height all the way down — which does NOT survive the
// real theme/mobile environment (dvh + safe-area + `overflow:auto` on the overlay),
// leaving the stage collapsed to its content (the ~480px embed box in card 60). As a
// flex child that is told to grow, the stage fills the overlay's main axis
// regardless of whether the percentage height resolves. `min-height:100%` is kept as
// the floor so the stage is never shorter than the viewport.
function applyTakeoverContainer(container, style) {
  const s = container.style;
  s.position = "relative";
  s.pointerEvents = "auto";
  s.background = "transparent"; // the bleed lives on the overlay
  s.borderRadius = "0";
  s.boxSizing = "border-box";
  s.width = "100%";
  s.maxWidth = "100%";
  s.flex = "1 1 auto"; // GROW to fill the overlay's main axis (not percent-height)
  s.height = "100%";
  s.minHeight = "100%";
  s.display = "flex";
  s.flexDirection = "column";
}

// Pill-radius default for takeover buttons: fully rounded unless the element author
// overrode radius via props.style.radius (element applyStyle runs after this and its
// explicit value wins). Also inherits the store font + antialiases the type so the
// answer pills read like the Gruns reference.
function applyTakeoverButtonDefaults(node) {
  const s = node.style;
  if (!s.borderRadius) s.borderRadius = "999px";
  s.fontFamily = "inherit";
  s.webkitFontSmoothing = "antialiased";
}

// Opening transition: a cinematic 1200ms opacity fade from 0→1 on a
// cubic-bezier(0.33, 0.0, 0.2, 1) gentle-landing curve — the container stays clearly
// translucent through the middle and solidifies on a slow tail rather than snapping
// solid, matching the gruns.co takeover entry. Pure fade — no rise/transform, so it
// reads as a gentle wash-in rather than an instant pop. For the transition the
// container is promoted to its own GPU/compositor layer via `will-change: opacity`
// (opacity alone is enough to promote a layer, so no translateZ hack is needed and the
// strict opacity-only contract holds); the hint is dropped on `transitionend` so we
// never hold the extra layer forever. No-op (respecting the user's motion preference)
// when prefers-reduced-motion is set — the container is shown immediately at rest with
// no opacity/transform/will-change churn.
function animateOpen(container, win) {
  const s = container.style;
  const reduce = prefersReducedMotion(win);
  if (reduce) {
    s.opacity = "1";
    s.transform = "none";
    return;
  }
  s.opacity = "0";
  s.willChange = "opacity"; // promote to a GPU layer for the fade (opacity-only)
  s.transition = "opacity 1200ms cubic-bezier(0.33, 0.0, 0.2, 1)";
  // One-shot, self-removing transitionend: release the compositor layer once the
  // container's own opacity fade lands so we never hold it forever. Guarded for
  // environments without addEventListener.
  if (container.addEventListener) {
    const onEnd = (event) => {
      if (event && event.target && event.target !== container) return;
      if (event && event.propertyName && event.propertyName !== "opacity") return;
      s.willChange = "auto";
      container.removeEventListener("transitionend", onEnd);
    };
    container.addEventListener("transitionend", onEnd);
  }
  const raf = win && typeof win.requestAnimationFrame === "function"
    ? win.requestAnimationFrame.bind(win)
    : (cb) => (win && win.setTimeout ? win.setTimeout(cb, 0) : cb());
  raf(() => { s.opacity = "1"; });
}

function prefersReducedMotion(win) {
  try {
    return !!(win && typeof win.matchMedia === "function"
      && win.matchMedia("(prefers-reduced-motion: reduce)").matches);
  } catch {
    return false;
  }
}

// Brand palette for the contrast-aware close disc.
const CHALK = "#F4F5F0";     // light brand surface / glyph
const OBSIDIAN = "#111210";  // dark brand surface / glyph
const CHALK_RGB = [244, 245, 240];   // parsed #F4F5F0
const OBSIDIAN_RGB = [17, 18, 16];   // parsed #111210
// Snap trigger: if the channel-inverted disc lands within this WCAG contrast ratio
// of the background (the mid-tone invert problem, e.g. #808080 → #7f7f7f ≈ 1:1) we
// abandon the invert and snap to a pure brand color so the X is never near-invisible.
const CONTRAST_MIN = 3;

// PURE contrast helper: is the given CSS color a LIGHT background? Computes a simple
// (NON-gamma) relative luminance (0.2126R + 0.7152G + 0.0722B on 0..1 channels) and
// returns true when it clears ~0.5. NOTE: this deliberately does NOT reuse the WCAG
// `relLuminance` below — its historical threshold behavior (e.g. #808080 → light) is
// pinned by tests and must stay identical; the gamma-linearized WCAG curve would flip
// mid-greys. Anything unparseable / empty / non-string returns false (the DARK
// default), the safe/visible fallback when the color can't be read (gradient / unknown
// name), so the disc is never light-on-light-invisible.
function isLightBackground(bg) {
  const rgb = parseColor(bg);
  if (!rgb) return false;
  const chan = (c) => c / 255;
  const lum = 0.2126 * chan(rgb[0]) + 0.7152 * chan(rgb[1]) + 0.0722 * chan(rgb[2]);
  return lum > 0.5;
}

// A small named-color map. CSS defines `transparent` as transparent black, so its RGB
// channels resolve to black for the invert math; any miss falls through to `null` so
// the disc drops to the luminance fallback (never invisible) rather than guessing.
const NAMED = {
  white: [255, 255, 255], black: [0, 0, 0], transparent: [0, 0, 0],
  red: [255, 0, 0], green: [0, 128, 0], blue: [0, 0, 255],
  gray: [128, 128, 128], grey: [128, 128, 128],
};

// Parse a CSS color to [r,g,b] 0..255, or null. Handles 3/4/6/8-digit hex (alpha
// ignored for the color math), rgb()/rgba(), hsl()/hsla() (converted to RGB) and the
// small NAMED map. Unparseable / gradient → null.
function parseColor(bg) {
  if (typeof bg !== "string") return null;
  const str = bg.trim();
  const hex = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.exec(str);
  if (hex) {
    let h = hex[1];
    if (h.length === 3 || h.length === 4) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }
  const rgb = /^rgba?\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)/i.exec(str);
  if (rgb) {
    const parts = [rgb[1], rgb[2], rgb[3]].map((n) => Math.round(Number(n)));
    if (parts.some((n) => !Number.isFinite(n) || n < 0 || n > 255)) return null;
    return parts;
  }
  const hsl = /^hsla?\(\s*([0-9.]+)\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%/i.exec(str);
  if (hsl) {
    const nums = [hsl[1], hsl[2], hsl[3]].map(Number);
    if (nums.some((n) => !Number.isFinite(n))) return null;
    return hslToRgb(nums[0], nums[1] / 100, nums[2] / 100);
  }
  return NAMED[str.toLowerCase()] ? NAMED[str.toLowerCase()].slice() : null;
}

// Standard HSL→RGB (h in degrees, s/l in 0..1) → [r,g,b] 0..255.
function hslToRgb(h, s, l) {
  h = ((h % 360) + 360) % 360;
  s = Math.max(0, Math.min(1, s));
  l = Math.max(0, Math.min(1, l));
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;
  let rgb;
  if (h < 60) rgb = [c, x, 0];
  else if (h < 120) rgb = [x, c, 0];
  else if (h < 180) rgb = [0, c, x];
  else if (h < 240) rgb = [0, x, c];
  else if (h < 300) rgb = [x, 0, c];
  else rgb = [c, 0, x];
  return rgb.map((v) => Math.round((v + m) * 255));
}

// WCAG relative luminance (gamma-linearized channels). Used ONLY for the disc/bg
// contrast guarantee (see the isLightBackground note on why it is not shared).
function relLuminance(rgb) {
  const lin = (c) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * lin(rgb[0]) + 0.7152 * lin(rgb[1]) + 0.0722 * lin(rgb[2]);
}

// WCAG contrast ratio between two [r,g,b] colors: (Lhi + 0.05) / (Llo + 0.05), 1..21.
function contrastRatio(a, b) {
  const la = relLuminance(a);
  const lb = relLuminance(b);
  const hi = Math.max(la, lb);
  const lo = Math.min(la, lb);
  return (hi + 0.05) / (lo + 0.05);
}

// PURE close-disc color resolver. Glyph = the background color; disc = the channel-
// inverted background, so the X reads as a filled disc of the bg color cut out of its
// own inverse — with a HARD contrast guarantee. Steps:
//   1. Unparseable bg (gradient / unknown name / non-string) → the historical safe
//      luminance fallback: light bg → OBSIDIAN disc / CHALK glyph, else the reverse.
//   2. Parseable bg → invert. If the inverse is within CONTRAST_MIN of the bg (the
//      mid-tone collapse) snap the disc to whichever pure brand color keeps the most
//      contrast (glyph = the opposite brand color) so the disc is provably visible.
//   3. Otherwise disc = rgb(inverse), glyph = the OPAQUE rgb() of the parsed bg (we
//      echo the solid color, never an rgba alpha, so the glyph reads solid).
function takeoverCloseColors(background) {
  const rgb = parseColor(background);
  if (!rgb) {
    return isLightBackground(background)
      ? { disc: OBSIDIAN, glyph: CHALK }
      : { disc: CHALK, glyph: OBSIDIAN };
  }
  const inv = [255 - rgb[0], 255 - rgb[1], 255 - rgb[2]];
  if (contrastRatio(inv, rgb) < CONTRAST_MIN) {
    return contrastRatio(OBSIDIAN_RGB, rgb) >= contrastRatio(CHALK_RGB, rgb)
      ? { disc: OBSIDIAN, glyph: CHALK }
      : { disc: CHALK, glyph: OBSIDIAN };
  }
  return {
    disc: `rgb(${inv[0]}, ${inv[1]}, ${inv[2]})`,
    glyph: `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`,
  };
}

// On-brand SOLID FILLED close disc, top-right (Gruns reference). Contrast-aware and
// model-driven: reads the resolved popup `background` and colors the ~38px filled disc
// as the channel-INVERTED background with the glyph in the background color itself, so
// the disc reads as the bg color cut from its inverse. A hard snap to a pure brand
// color kicks in for mid-tone backgrounds whose invert would collapse toward them, so
// the X is always visible (see takeoverCloseColors). Lift shadow + cheap inline
// hover/active feedback; fires the dismiss path onClick.
function buildTakeoverCloseButton(doc, onClick, background) {
  const btn = doc.createElement("button");
  btn.setAttribute("type", "button");
  btn.setAttribute("aria-label", "Close");
  btn.setAttribute("data-szn-takeover-close", "1");
  btn.textContent = "×";
  const { disc, glyph } = takeoverCloseColors(background);
  const s = btn.style;
  s.position = "absolute";
  // Inset is ADDITIVE with the safe-area inset so the X is never clipped: on a
  // notched device the notch inset STACKS on top of a 16px base (card 66 bug 2).
  // The previous `max(16px, env(...))` picked ONE value, so with a 0 inset the
  // button could sit flush at the top-right corner and read as half-clipped.
  // `calc(env(...) + 16px)` is always >=16px (>=12px + inset) from the popup's
  // top-right corner.
  s.top = "calc(env(safe-area-inset-top) + 16px)";
  s.right = "calc(env(safe-area-inset-right) + 16px)";
  s.zIndex = "2";
  s.width = "38px";
  s.height = "38px";
  s.lineHeight = "38px";
  s.padding = "0";
  s.borderRadius = "999px";
  s.border = "none";
  s.background = disc;
  s.color = glyph;
  s.boxShadow = "0 2px 8px rgba(0,0,0,.18)";
  s.fontSize = "22px";
  s.cursor = "pointer";
  s.webkitFontSmoothing = "antialiased";
  wireDiscFeedback(btn);
  btn.addEventListener("click", onClick);
  return btn;
}

// Cheap inline hover/active feedback on the injected node — no CSS injection, just
// style toggles on mouseenter/leave (subtle grow) and mousedown/up (press). Kept
// light so the fake-DOM tests only need to confirm the base treatment.
function wireDiscFeedback(btn) {
  const s = btn.style;
  s.transition = "transform 120ms ease, opacity 120ms ease";
  btn.addEventListener("mouseenter", () => { s.transform = "scale(1.05)"; });
  btn.addEventListener("mouseleave", () => { s.transform = "scale(1)"; s.opacity = "1"; });
  btn.addEventListener("mousedown", () => { s.transform = "scale(0.95)"; s.opacity = "0.9"; });
  btn.addEventListener("mouseup", () => { s.transform = "scale(1.05)"; s.opacity = "1"; });
}

// element → DOM for the storefront popup widget (card 41). ONE switch that READS
// the registry element kinds (heading/text/button/image/email/badge/divider/
// countdown/embed) and builds an absolutely-positioned node per element's x/y/w/h
// (percent coords) styled from `props`. The `embed` kind delegates to render-embed.js.
//
// SECURITY BOUNDARY: the model doc is untrusted at render time. This layer is
// OUTPUT-ENCODED — text goes through textContent (never innerHTML), and src/href
// attributes are allow-listed to http/https/root-relative via safeUrl (no
// javascript:/data: schemes). Nothing from `props` is ever executed.




// Position a node by the element's percentage coords. The dashboard/registry writes
// canonical FLAT coords `xPct/yPct/wPct/hPct` (0..100); the legacy `x/y/w/h` shape
// stays a fallback for older docs. Coords are percentages of the container. Missing
// coords fall back to a sane default.
//
// MOBILE DEFAULT (card 95): on a mobile viewport (≤600px, `isMobile === true`) an
// `embed` element goes FULL-BLEED — left:0/top:0/width:100%/height:100% — ignoring
// its stored desktop coords, because a narrow desktop-positioned embed (e.g. quiz at
// 30% width) is unusable clipped into ~117px on a phone. Pure: `isMobile` is passed
// in (never read from `window` here). Non-embed kinds keep their desktop coords on
// mobile for now (multi-element mobile layout is a future card).
function position(node, el, isMobile) {
  const s = node.style;
  s.position = "absolute";
  s.boxSizing = "border-box";
  if (isMobile === true && el && el.kind === "embed") {
    s.left = "0";
    s.top = "0";
    s.width = "100%";
    s.height = "100%";
    return;
  }
  s.left = pct(coord(el, "xPct", "x"), 0) + "%";
  s.top = pct(coord(el, "yPct", "y"), 0) + "%";
  s.width = pct(coord(el, "wPct", "w"), 100) + "%";
  const h = coord(el, "hPct", "h");
  if (typeof h === "number" && h > 0) s.height = h + "%";
}

// Read one coord: canonical (`xPct` etc.) wins, legacy (`x` etc.) is the fallback.
// Uses the same numeric guard as pct() so a legitimate `0` is honored (not treated
// as "unset"); returns the first value that IS a finite number, else undefined.
function coord(el, canonicalKey, legacyKey) {
  if (el && typeof el[canonicalKey] === "number" && isFinite(el[canonicalKey])) return el[canonicalKey];
  if (el && typeof el[legacyKey] === "number" && isFinite(el[legacyKey])) return el[legacyKey];
  return undefined;
}

function pct(v, dflt) {
  return typeof v === "number" && isFinite(v) ? v : dflt;
}

// The canonical FLAT visual map (mirrors the dashboard element registry, which
// writes visuals FLAT on `props`): prop name → { css, px }. Numeric `px` keys get
// a "px" suffix; string values pass through (so "12px" still works). This is the
// allow-list — no arbitrary CSS injection.
const VISUAL_MAP = {
  color: { css: "color" },
  background: { css: "background" },
  bg: { css: "background" },
  fontSize: { css: "fontSize", px: true },
  fontWeight: { css: "fontWeight" },
  align: { css: "textAlign" },
  radius: { css: "borderRadius", px: true },
};

// Read one visual value: FLAT `props[key]` wins (dashboard truth), then the legacy
// `props.style[key]` fallback (older docs). Returns null when neither is set.
function readVisual(props, key) {
  if (props && props[key] != null) return props[key];
  const st = props && props.style;
  if (st && typeof st === "object" && st[key] != null) return st[key];
  if (key === "fontWeight" && st && typeof st === "object" && st.weight != null) return st.weight;
  return null;
}

// Coerce a visual value to a CSS string. Numeric px keys get "px"; everything else
// is stringified (strings like "12px" pass through unchanged).
function cssValue(value, px) {
  if (px && typeof value === "number") return value + "px";
  return String(value);
}

// Apply the flat visual allow-list to a node — each value coerced to a string and
// assigned individually (no bulk cssText → keeps the no-CSS-injection guarantee).
function applyStyle(node, props) {
  if (!props || typeof props !== "object") return;
  for (const [key, def] of Object.entries(VISUAL_MAP)) {
    const value = readVisual(props, key);
    if (value != null) node.style[def.css] = cssValue(value, def.px);
  }
}

// --- per-kind builders (each returns a node; text via textContent only) --------

function buildHeading(doc, el) {
  const level = Number(el.props.level);
  const tag = level >= 1 && level <= 6 ? "h" + level : "h2";
  const node = doc.createElement(tag);
  node.textContent = str(el.props.text);
  return node;
}

function buildText(doc, el) {
  const node = doc.createElement("p");
  node.textContent = str(el.props.text);
  return node;
}

function buildBadge(doc, el) {
  const node = doc.createElement("span");
  node.textContent = str(el.props.text);
  node.setAttribute("data-tone", str(el.props.tone) || "default");
  return node;
}

function buildDivider(doc) {
  return doc.createElement("hr");
}

function buildImage(doc, el) {
  const node = doc.createElement("img");
  const src = safeUrl(el.props.src);
  if (src) node.setAttribute("src", src);
  node.setAttribute("alt", str(el.props.alt));
  node.style.objectFit = str(el.props.fit) || "cover";
  node.style.width = "100%";
  return node;
}

function buildButton(doc, el, ctx) {
  const node = doc.createElement("button");
  node.setAttribute("type", "button");
  node.textContent = str(el.props.text) || str(el.props.label) || "Continue";
  node.addEventListener("click", () => {
    if (ctx && typeof ctx.onButton === "function") ctx.onButton(el);
  });
  return node;
}

function buildEmail(doc, el, ctx) {
  const form = doc.createElement("form");
  const input = doc.createElement("input");
  input.setAttribute("type", "email");
  input.setAttribute("required", "required");
  input.setAttribute("placeholder", str(el.props.placeholder) || "Email");
  const submit = doc.createElement("button");
  submit.setAttribute("type", "submit");
  submit.textContent = str(el.props.cta) || "Get it";
  form.appendChild(input);
  form.appendChild(submit);
  form.addEventListener("submit", (event) => {
    if (event && typeof event.preventDefault === "function") event.preventDefault();
    if (ctx && typeof ctx.onEmail === "function") ctx.onEmail(input.value, el);
  });
  return form;
}

function buildCountdown(doc, el) {
  const node = doc.createElement("div");
  node.setAttribute("data-countdown", "1");
  const label = str(el.props.label);
  const endsAt = Date.parse(str(el.props.endsAt));
  node.textContent = isFinite(endsAt)
    ? (label ? label + " " : "") + formatRemaining(endsAt - Date.now())
    : label;
  return node;
}

// An embed is positioned by a percent `h` when the element carries a numeric height
// (the same guard `position()` uses). In that case the POSITIONED node must be a
// wrapper sized by the percent coords, with the iframe filling it 100%/100% — so a
// takeover embed at `h:66` maps to the screen instead of the iframe's own px height
// clamping the stage to a fixed 480px box (card 60). Without a percent `h`, the
// iframe itself is the positioned node and keeps its authored/fallback px height.
function embedIsPercentSized(el) {
  const h = coord(el, "hPct", "h");
  return typeof h === "number" && h > 0;
}

function buildEmbed(doc, el, ctx) {
  const fillParent = embedIsPercentSized(el);
  const frame = mountEmbed(
    el.props, (ctx && ctx.config) || {}, (action) => {
      if (ctx && typeof ctx.onEmbed === "function") ctx.onEmbed(action, el);
    },
    { document: doc, window: ctx && ctx.window, fillParent },
  );
  if (!frame) return doc.createElement("div"); // unsafe/missing url → empty placeholder
  if (!fillParent) return frame; // iframe is the positioned node (keeps its px height)
  // Percent `h`: the iframe fills a positioned wrapper. `position()` (in
  // renderElement) sizes THIS wrapper to the percent coords; the iframe fills it.
  const wrapper = doc.createElement("div");
  wrapper.appendChild(frame);
  return wrapper;
}

// mm:ss remaining, clamped at 0.
function formatRemaining(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0");
}

function str(v) {
  return typeof v === "string" ? v : (v == null ? "" : String(v));
}

// The kind → builder table. Reading the registry means a new kind is one entry.
const BUILDERS = {
  heading: buildHeading,
  text: buildText,
  badge: buildBadge,
  divider: buildDivider,
  image: buildImage,
  button: buildButton,
  email: buildEmail,
  countdown: buildCountdown,
  embed: buildEmbed,
};

// Render one element to a positioned node. Unknown kinds → an empty positioned div
// (forward-compat: a newer model kind renders as blank space, never throws).
function renderElement(doc, el, ctx = {}) {
  const props = el && typeof el.props === "object" && el.props ? el.props : {};
  const safeEl = { ...el, props };
  const build = BUILDERS[safeEl.kind];
  const node = build ? build(doc, safeEl, ctx) : doc.createElement("div");
  position(node, safeEl, ctx && ctx.isMobile === true);
  // Mark the embed's POSITIONED node so the popup can full-bleed it on the quiz result
  // step (card 113) via a CSS rule, without re-rendering (a re-render would reload the
  // iframe and lose the result). The mark rides on whichever node position() sized —
  // the iframe itself, or the percent-`h` wrapper.
  if (safeEl.kind === "embed" && node && typeof node.setAttribute === "function") {
    node.setAttribute("data-szn-embed", "1");
  }
  // Takeover buttons default to pill radius (card 49); applyStyle runs after, so an
  // explicit flat `radius` (or legacy `props.style.radius`) still wins.
  if (safeEl.kind === "button" && ctx && ctx.takeover) applyTakeoverButtonDefaults(node);
  applyStyle(node, props);
  return node;
}

// Render every element of a resolved popup into `container` (an element host).
function renderElements(doc, container, elements, ctx = {}) {
  const list = Array.isArray(elements) ? elements : [];
  for (const el of list) {
    if (!el || typeof el.kind !== "string") continue;
    container.appendChild(renderElement(doc, el, ctx));
  }
  return container;
}

// SZN popup — result-step embed widen (card 113). ONE JOB: on the quiz RESULT step the
// popup full-bleeds the quiz embed so the two-column conversion screen covers much more
// of the popup; on any earlier step it reverts to the narrow authored geometry.
//
// Rather than re-render the element host (which would tear down + RELOAD the iframe and
// lose the user's result), we flip an attribute on the popup CONTAINER that a
// widget-owned CSS rule reads to override the marked embed node's positioned geometry to
// full-bleed. The quiz iframe is transparent, so full-bleeding it keeps the popup's cans
// showing around the centered result card. Mobile embeds are already full-bleed
// (card 95), so this is a visual no-op there. The attribute lives on the container (not
// the host), so a breakpoint re-render of the host preserves the wide state.
//
// The `[data-szn-embed="1"]` marker is stamped on the embed's positioned node by
// render-elements.js. Deps (doc) are passed in so this unit-tests with a fake DOM.

const EMBED_WIDE_ATTR = "data-szn-embed-wide";
const EMBED_WIDE_STYLE_ID = "szn-embed-wide";
const EMBED_WIDE_CSS =
  "[" + EMBED_WIDE_ATTR + '="1"] [data-szn-embed="1"]{' +
  "position:absolute!important;inset:0!important;left:0!important;top:0!important;" +
  "width:100%!important;height:100%!important;}";

// Inject the widget-owned widen rule into <head> exactly once (idempotent across
// re-opens). No-op with no head / createElement (node tests with a bare fake doc) — the
// attribute toggle still runs, so the wiring is testable without a real stylesheet.
function ensureEmbedWideStyle(doc) {
  if (!doc || !doc.head || typeof doc.createElement !== "function") return;
  if (typeof doc.getElementById === "function" && doc.getElementById(EMBED_WIDE_STYLE_ID)) return;
  const style = doc.createElement("style");
  style.id = EMBED_WIDE_STYLE_ID;
  if (typeof style.setAttribute === "function") style.setAttribute("id", EMBED_WIDE_STYLE_ID);
  style.textContent = EMBED_WIDE_CSS;
  doc.head.appendChild(style);
}

// Toggle the widen state on the popup container. `wide === true` full-bleeds the embed
// (and ensures the rule is injected); anything else reverts to the authored geometry.
function setEmbedWide(doc, container, wide) {
  const on = wide === true;
  if (container && typeof container.setAttribute === "function") {
    container.setAttribute(EMBED_WIDE_ATTR, on ? "1" : "0");
  }
  if (on) ensureEmbedWideStyle(doc);
}

const __embedWide = { EMBED_WIDE_ATTR, EMBED_WIDE_STYLE_ID, EMBED_WIDE_CSS };

// Popup-level shell for the storefront widget (cards 41, 49). Builds an overlay + a
// positioned container honoring the popup `type` (takeover = full-screen edge-to-edge
// takeover, slide-in = corner card, bar = full-width strip) and any `style`
// (bg/overlay/width). Takeover-only geometry + polish (full-bleed, pill buttons,
// opening transition, circle close X) lives in takeover-layout.js. Composes the
// elements via render-elements.js, and owns the open/close lifecycle: focus +
// scroll-lock + ESC-close (takeover) on open, restore + unbind on close. DOM-only
// glue; the document/window are injected so the wiring is exercisable jsdom-free.






// Layout presets per popup type. Reads the resolved popup's `type`; an unknown
// type falls back to takeover so a newer model type still shows. `place: "takeover"`
// is the full-screen Gruns takeover (card 49); "center" is the legacy centered modal
// (unused by presentation types now, kept for any doc that still requests it).
function layoutFor(type) {
  if (type === "slide-in") return { modal: false, place: "corner" };
  if (type === "bar") return { modal: false, place: "bar" };
  return { modal: true, place: "takeover" }; // takeover / legacy / unknown
}

function applyContainerLayout(container, layout, style) {
  // Full-screen takeover geometry lives in takeover-layout.js (one file, one job).
  if (layout.place === "takeover") { applyTakeoverContainer(container, style); return; }
  const s = container.style;
  s.position = "relative";
  s.background = popupStyleString(style.background) || "#fff";
  // Optional cover backdrop layered over the color. Only set when the authored
  // URL survives the safeUrl allow-list AND the CSS url() escape — otherwise the
  // color layer above is left untouched (byte-identical to no-image behavior).
  const bgImage = popupBackgroundImage(style.background_image);
  if (bgImage) {
    s.backgroundImage = bgImage;
    s.backgroundSize = "cover";
    s.backgroundPosition = "center";
  }
  s.borderRadius = popupStyleString(style.radius) || (layout.place === "bar" ? "0" : "12px");
  s.boxSizing = "border-box";
  s.overflow = "hidden";
  if (layout.place === "corner") {
    s.width = popupStyleString(style.width) || "340px";
    s.minHeight = popupStyleString(style.height) || "220px";
  } else { // bar
    s.width = "100%";
    s.minHeight = popupStyleString(style.height) || "72px";
  }
}

function applyOverlay(overlay, layout, style) {
  // Full-bleed takeover overlay lives in takeover-layout.js.
  if (layout.place === "takeover") { applyTakeoverOverlay(overlay, style); return; }
  const s = overlay.style;
  s.position = "fixed";
  s.zIndex = "2147483000";
  s.inset = "0";
  s.display = "flex";
  if (layout.place === "corner") {
    s.alignItems = "flex-end";
    s.justifyContent = "flex-end";
    s.padding = "16px";
    s.pointerEvents = "none";
    s.background = "transparent";
  } else { // bar
    s.alignItems = "flex-start";
    s.justifyContent = "center";
    s.background = "transparent";
    s.pointerEvents = "none";
  }
}

function popupStyleString(v) {
  return typeof v === "string" ? v : "";
}

// --- Intercom/Fin launcher hide while a popup is open (card 97) ---------------
// The messenger bubble (bottom-right) overlaps the popup takeover. On OPEN we tag
// <html> with `szn-popup-open` and inject a widget-owned style rule that hides the
// launcher across the class names Intercom ships; on CLOSE we remove the class and
// restore. The class+CSS approach does NOT depend on the Intercom API having loaded;
// the `Intercom('update', …)` call is a belt-and-suspenders (guarded for undefined).
const LAUNCHER_HIDE_CLASS = "szn-popup-open";
const LAUNCHER_HIDE_STYLE_ID = "szn-popup-launcher-hide";
const LAUNCHER_HIDE_CSS =
  "html." + LAUNCHER_HIDE_CLASS + " #intercom-container," +
  "html." + LAUNCHER_HIDE_CLASS + " .intercom-lightweight-app," +
  "html." + LAUNCHER_HIDE_CLASS + " iframe.intercom-launcher-frame," +
  "html." + LAUNCHER_HIDE_CLASS + " .intercom-launcher-frame{display:none !important;}";
const launcherHideDepthByDoc = new WeakMap();

// Inject the widget-owned hide rule into <head> exactly once (idempotent across
// re-opens / multiple popups). No-op when there's no head / createElement (node test
// with a bare fake doc) — the class toggle + Intercom call still run.
function ensureLauncherHideStyle(doc) {
  if (!doc || !doc.head || typeof doc.createElement !== "function") return;
  if (typeof doc.getElementById === "function" && doc.getElementById(LAUNCHER_HIDE_STYLE_ID)) return;
  const style = doc.createElement("style");
  style.id = LAUNCHER_HIDE_STYLE_ID;
  if (typeof style.setAttribute === "function") style.setAttribute("id", LAUNCHER_HIDE_STYLE_ID);
  style.textContent = LAUNCHER_HIDE_CSS;
  doc.head.appendChild(style);
}

// Belt-and-suspenders: ask Intercom directly to hide/show the default launcher.
// Guarded for undefined so a page without Intercom loaded is a safe no-op.
function setIntercomLauncherHidden(win, hidden) {
  try {
    if (win && typeof win.Intercom === "function") {
      win.Intercom("update", { hide_default_launcher: !!hidden });
    }
  } catch { /* launcher toggle must never break the popup lifecycle */ }
}

// Toggle the <html> hide class. Uses classList when present (real DOM), else falls
// back to className string editing so this stays testable with a minimal fake node.
function toggleLauncherHide(doc, win, on) {
  const html = doc && doc.documentElement;
  const currentDepth = doc ? (launcherHideDepthByDoc.get(doc) || 0) : 0;
  let nextDepth = currentDepth;
  if (on) {
    nextDepth = currentDepth + 1;
  } else if (currentDepth > 0) {
    nextDepth = currentDepth - 1;
  }
  if (doc) {
    if (nextDepth > 0) launcherHideDepthByDoc.set(doc, nextDepth);
    else launcherHideDepthByDoc.delete(doc);
  }
  const shouldHide = nextDepth > 0;
  if (html) {
    if (html.classList && typeof html.classList.add === "function") {
      if (shouldHide) html.classList.add(LAUNCHER_HIDE_CLASS); else html.classList.remove(LAUNCHER_HIDE_CLASS);
    } else {
      const cur = (html.className || "").split(/\s+/).filter(Boolean).filter((c) => c !== LAUNCHER_HIDE_CLASS);
      if (shouldHide) cur.push(LAUNCHER_HIDE_CLASS);
      html.className = cur.join(" ");
    }
  }
  if (shouldHide) ensureLauncherHideStyle(doc);
  if (on || nextDepth === 0) setIntercomLauncherHidden(win, shouldHide);
}

// The mobile breakpoint query (card 95). One place so the render-time read and the
// live `change` listener can never disagree.
const MOBILE_MQ = "(max-width: 600px)";

// Read the mobile MediaQueryList off the injected window, or null when matchMedia is
// unavailable (SSR / node --test with no DOM). Pure w.r.t. globals — reads only the
// passed window, never a hard `window` reference.
function mobileMql(win) {
  if (!win || typeof win.matchMedia !== "function") return null;
  try { return win.matchMedia(MOBILE_MQ); } catch { return null; }
}

// Is the viewport mobile (≤600px) right now? Falls back to `false` when matchMedia is
// unavailable — desktop geometry is the safe default (byte-identical to today for any
// caller that doesn't inject a matchMedia window).
function detectMobile(win) {
  const mql = mobileMql(win);
  return !!(mql && mql.matches === true);
}

// Resolve an authored background_image URL into a safe CSS `url("...")` value, or
// "" when it must be skipped. Two gates: (1) safeUrl allow-lists the scheme
// (http/https/root-relative — drops javascript:/data:), same discipline as image
// src/href; (2) since this lands in a CSS DECLARATION (not an attribute), the URL
// is escaped for the url("...") context so a valid https URL containing `"`, `)`,
// `\` or newlines/control chars cannot break out of the declaration and inject a
// second property. Backslash-escape `\`, `"`, `(`, `)`; strip newlines/controls.
function popupBackgroundImage(raw) {
  const url = safeUrl(raw);
  if (!url) return "";
  const escaped = url
    .replace(/[\x00-\x1f\x7f]/g, "")       // strip control chars incl. newlines
    .replace(/[\\"()]/g, "\\$&");          // escape url("...") breakout chars
  return `url("${escaped}")`;
}

// Build the popup shell for a RESOLVED popup. `ctx` carries the element callbacks
// (onButton/onEmail/onEmbed) + widget config + window. Returns a controller
// { node, open, close } — node is the overlay to append; open()/close() manage
// lifecycle. `onClose` (in ctx) is invoked when the popup dismisses (any path).
function buildPopup(doc, popup, ctx = {}) {
  const type = normalizeType(popup && popup.type);
  const layout = layoutFor(type);
  const style = (popup && popup.style) || {};

  const overlay = doc.createElement("div");
  overlay.setAttribute("data-szn-popup", (popup && popup.id) || "");
  applyOverlay(overlay, layout, style);

  const container = doc.createElement("div");
  container.setAttribute("role", "dialog");
  container.setAttribute("aria-modal", layout.modal ? "true" : "false");
  container.style.pointerEvents = "auto";
  applyContainerLayout(container, layout, style);

  const dismiss = (source) => { closeFn(source); };

  // Close affordance. Takeover is ALWAYS closable (an unclosable full-screen
  // takeover is not shippable) and gets the on-brand circle X; slide-in/bar keep
  // the style.noClose opt-out and the minimal corner ×.
  if (layout.place === "takeover") {
    container.appendChild(buildTakeoverCloseButton(doc, () => dismiss("button"), style.background));
  } else if (!style.noClose) {
    container.appendChild(buildCloseButton(doc, () => dismiss("button")));
  }

  // Element host fills the container; elements position themselves within it. For
  // takeover the host is inset:0 of a full-viewport container, so percent coords map
  // to the full screen. Flag the ctx so buttons default to pill radius (card 49).
  const host = doc.createElement("div");
  host.style.position = "absolute";
  host.style.inset = "0";
  container.appendChild(host);
  const baseElCtx = layout.place === "takeover" ? { ...ctx, takeover: true } : { ...ctx };
  const elements = popup && popup.elements;

  // Render (or RE-render, card 95) the element host for a given viewport mode. On a
  // re-render the previous embeds are torn down first (their postMessage listeners
  // unbound) and the host emptied, so switching across the 600px breakpoint never
  // leaks a listener or stacks stale nodes. `isMobile` flows into `position()` so an
  // embed goes full-bleed on mobile / keeps its desktop coords above the breakpoint.
  let currentMobile = detectMobile(ctx.window);
  function renderHost(mobile) {
    teardownEmbeds(host);
    while (host.children && host.children.length) {
      host.removeChild(host.children[host.children.length - 1]);
    }
    renderElements(doc, host, elements, { ...baseElCtx, isMobile: mobile === true });
  }
  renderHost(currentMobile);

  overlay.appendChild(container);

  // Overlay backdrop click closes a modal takeover (not the corner/bar variants).
  if (layout.modal) {
    overlay.addEventListener("click", (event) => {
      if (event && event.target === overlay) dismiss("backdrop");
    });
  }

  let opened = false;
  let restoreOverflow = "";
  const body = doc.body;
  const win = ctx.window;

  // ESC-close for takeover (desktop). Registered on the injected window on open,
  // removed on close so a re-opened popup never double-binds.
  let escHandler = null;
  function bindEsc() {
    if (layout.place !== "takeover" || !win || typeof win.addEventListener !== "function") return;
    escHandler = (event) => {
      const key = event && (event.key || event.code);
      if (key === "Escape" || key === "Esc") dismiss("escape");
    };
    win.addEventListener("keydown", escHandler);
  }
  function unbindEsc() {
    if (escHandler && win && typeof win.removeEventListener === "function") {
      win.removeEventListener("keydown", escHandler);
    }
    escHandler = null;
  }

  // Live breakpoint switch (card 95). While the popup is open, watch the mobile media
  // query; when it flips (rotate a phone, resize across 600px) recompute and re-render
  // the host so the embed toggles between full-bleed (mobile) and desktop geometry.
  // Prefers the MQL `change` event; falls back to `addListener` (legacy) and a window
  // `resize` handler when matchMedia has no event API. Bound on open, removed on close
  // so a re-opened popup never double-binds.
  let mqCleanup = null;
  function bindBreakpoint() {
    const mql = mobileMql(win);
    const onChange = () => {
      const next = detectMobile(win);
      if (next === currentMobile) return;
      currentMobile = next;
      renderHost(next);
    };
    if (mql && typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);
      mqCleanup = () => { try { mql.removeEventListener("change", onChange); } catch { /* ignore */ } };
    } else if (mql && typeof mql.addListener === "function") {
      mql.addListener(onChange); // legacy Safari MediaQueryList API
      mqCleanup = () => { try { mql.removeListener(onChange); } catch { /* ignore */ } };
    } else if (win && typeof win.addEventListener === "function") {
      win.addEventListener("resize", onChange);
      win.addEventListener("orientationchange", onChange);
      mqCleanup = () => {
        win.removeEventListener("resize", onChange);
        win.removeEventListener("orientationchange", onChange);
      };
    }
  }
  function unbindBreakpoint() {
    if (typeof mqCleanup === "function") mqCleanup();
    mqCleanup = null;
  }
  function syncBreakpoint() {
    const next = detectMobile(win);
    if (next === currentMobile) return;
    currentMobile = next;
    renderHost(next);
  }

  function openFn() {
    if (opened) return;
    opened = true;
    syncBreakpoint();
    if (body) body.appendChild(overlay);
    if (layout.modal && body) {
      restoreOverflow = body.style.overflow;
      body.style.overflow = "hidden"; // scroll-lock the page under a modal
    }
    bindEsc();
    bindBreakpoint();
    toggleLauncherHide(doc, win, true); // hide the Intercom launcher under the popup (card 97)
    if (layout.place === "takeover") animateOpen(container, win);
    try {
      const focusable = container.querySelector && container.querySelector("button, input, a");
      if (focusable && typeof focusable.focus === "function") focusable.focus();
    } catch { /* focus is best-effort */ }
  }

  function closeFn(source) {
    if (!opened) return;
    opened = false;
    unbindEsc();
    unbindBreakpoint();
    toggleLauncherHide(doc, win, false); // restore the Intercom launcher on any dismiss path (card 97)
    if (layout.modal && body) body.style.overflow = restoreOverflow;
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    teardownEmbeds(container);
    if (typeof ctx.onClose === "function") ctx.onClose(source);
  }

  // Card 113: widen (result) / revert (any earlier step) the quiz embed. The widen
  // attribute lives on `container` (NOT `host`), so a breakpoint re-render of the host
  // preserves the wide state. widget.js maps the funnel's step broadcast to this.
  const setResultWide = (wide) => setEmbedWide(doc, container, wide);

  return { node: overlay, container, open: openFn, close: (src) => closeFn(src || "api"), setResultWide };
}

// A minimal accessible close button.
function buildCloseButton(doc, onClick) {
  const btn = doc.createElement("button");
  btn.setAttribute("type", "button");
  btn.setAttribute("aria-label", "Close");
  btn.textContent = "×";
  btn.style.position = "absolute";
  btn.style.top = "8px";
  btn.style.right = "8px";
  btn.style.zIndex = "1";
  btn.addEventListener("click", onClick);
  return btn;
}

// Remove any message listeners embeds registered (render-embed stashes a cleanup).
function teardownEmbeds(container) {
  try {
    const frames = container.querySelectorAll ? container.querySelectorAll("iframe") : [];
    frames.forEach((f) => { if (typeof f._sznCleanup === "function") f._sznCleanup(); });
  } catch { /* ignore */ }
}

// PURE preview-mode helpers for the storefront popup widget (card 50). When the
// page URL carries `szn-popup-preview=<id>` (optionally `szn-popup-variant=<key>`),
// the widget force-shows that one popup — even a draft — bypassing
// trigger/targeting/frequency and firing ZERO analytics. This module owns only the
// param parsing + variant choice; it has NO DOM and NO globals, so it runs under
// `node --test`. The ids/keys are UNTRUSTED URL input, validated here before they
// ever reach the API query string or a variant lookup.
//
// It must NOT import api/popups-model.js (that pulls in `pg`, server-only, and must
// never enter the browser bundle), so it mirrors that file's id-rule regex locally.


// Same allowlist as api/popups-model.js isValidId: lowercase alnum + hyphen,
// 1..64 chars, must start alnum. Rejects "UPPER", "a/b", "", too long, and any
// path/query-injection shape.
const PREVIEW_ID_RE = /^[a-z0-9][a-z0-9-]{0,63}$/;

function isValidPreviewKey(v) {
  return typeof v === "string" && PREVIEW_ID_RE.test(v);
}

// Parse the preview request off a location.search string.
//   parsePreviewRequest("?szn-popup-preview=welcome") -> { id: "welcome" }
//   ...&szn-popup-variant=b                            -> { id, variantKey: "b" }
// Returns null when there is no (valid) preview id. An invalid variant key is
// DROPPED (the id is kept so a plain base preview still works); an invalid/missing
// id yields null (no preview at all).
function parsePreviewRequest(search) {
  let params;
  try {
    params = new URLSearchParams(typeof search === "string" ? search : "");
  } catch {
    return null;
  }
  const id = params.get("szn-popup-preview");
  if (!isValidPreviewKey(id)) return null;
  const key = params.get("szn-popup-variant");
  return isValidPreviewKey(key) ? { id, variantKey: key } : { id };
}

// Build the preview API URL: get-one by id, optional variant, always preview=1.
// `base` is the API origin (no trailing slash expected; caller strips it). Both id
// and variant are percent-encoded — they are already validated, but encode anyway
// so the query string is well-formed.
function previewApiUrl(base, id, variantKey) {
  const root = typeof base === "string" ? base.replace(/\/+$/, "") : "";
  const parts = ["id=" + encodeURIComponent(id)];
  if (variantKey) parts.push("variant=" + encodeURIComponent(variantKey));
  parts.push("preview=1");
  return root + "/api/popups?" + parts.join("&");
}

// Decide which variant to show in preview and resolve its effective popup.
//   choosePreviewVariant(popup, "b")  -> { variantKey: "b", resolved: merged }
//   choosePreviewVariant(popup)       -> first variant when variants[] non-empty,
//                                         else the base popup
//   unknown key                       -> base (via resolvePopupVariant's fallback)
// Returns { variantKey, resolved }. variantKey is the key actually applied (null
// when the base was used).
function choosePreviewVariant(popup, variantKey) {
  const base = popup || {};
  if (variantKey) {
    return { variantKey, resolved: resolvePopupVariant(base, variantKey) };
  }
  const variants = Array.isArray(base.variants) ? base.variants : [];
  const first = variants.find((v) => v && typeof v.key === "string");
  if (first) {
    return { variantKey: first.key, resolved: resolvePopupVariant(base, first.key) };
  }
  return { variantKey: null, resolved: base };
}

// Offer handoff persistence for the storefront popup widget (card 51). When a
// visitor earns an offer in the popup (plinko win / quiz coded complete, or a
// button carrying a discount code), we persist a NON-SECRET, client-local offer
// record so the outcome follows them to the PDP and a top banner can re-surface it
// on every subsequent page load. Mirrors frequency-store.js exactly: injectable
// storages (default to window globals), every access try/catch-wrapped so a
// blocked/absent storage never throws, JSON.parse guarded, pure + node-testable.
//
// Durable record in localStorage under `szn_popup_offer`:
//   { popupId, code, discount, banner, ts }  (ts = ms epoch, drives the TTL)
// with a 48h TTL — an earned code is short-lived, not a permanent tag. A
// PER-SESSION dismiss flag lives in sessionStorage under `szn_popup_offer_dismissed`
// so a manual dismiss is remembered for the tab lifetime (resets on a new session).

const OFFER_KEY = "szn_popup_offer";
const OFFER_DISMISS_KEY = "szn_popup_offer_dismissed";

// 48 hours. An earned offer follows the visitor across the session/PDP hop, but a
// stale record self-clears rather than haunting a return visit days later.
const OFFER_TTL_MS = 48 * 60 * 60 * 1000;

function offerStorage() {
  try {
    if (typeof localStorage !== "undefined") return localStorage;
  } catch { /* access can throw in sandboxed frames */ }
  return null;
}

function offerSession() {
  try {
    if (typeof sessionStorage !== "undefined") return sessionStorage;
  } catch { /* access can throw in sandboxed frames */ }
  return null;
}

function isOfferObject(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}

// Persist an earned offer. Stamps `ts` at `now` (drives TTL). Requires at least a
// code (nothing to hand off without it); no-ops otherwise. Swallows quota/blocked.
function saveOffer(offer, storage = offerStorage(), now = Date.now()) {
  if (!storage || !isOfferObject(offer) || !offer.code) return;
  const record = {
    popupId: typeof offer.popupId === "string" ? offer.popupId : null,
    code: offer.code,
    discount: offer.discount != null ? offer.discount : null,
    banner: typeof offer.banner === "string" ? offer.banner : null,
    ts: typeof now === "number" ? now : Date.now(),
  };
  try {
    storage.setItem(OFFER_KEY, JSON.stringify(record));
  } catch { /* quota / private mode — offer just won't persist */ }
}

// Read the stored offer, or null. Returns null AND clears the record on expiry
// (older than the TTL) or corruption, so a stale/garbage entry never re-surfaces.
function readOffer(storage = offerStorage(), now = Date.now()) {
  if (!storage) return null;
  let raw;
  try {
    raw = storage.getItem(OFFER_KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    clearOffer(storage);
    return null;
  }
  if (!isOfferObject(parsed) || !parsed.code || typeof parsed.ts !== "number") {
    clearOffer(storage);
    return null;
  }
  const at = typeof now === "number" ? now : Date.now();
  if (at - parsed.ts > OFFER_TTL_MS) {
    clearOffer(storage);
    return null;
  }
  return parsed;
}

// Remove the stored offer (QA / consumed / expired). Swallows any error.
function clearOffer(storage = offerStorage()) {
  if (!storage) return;
  try { storage.removeItem(OFFER_KEY); } catch { /* ignore */ }
}

// Has the banner been dismissed in THIS session (tab lifetime)?
function isDismissed(session = offerSession()) {
  if (!session) return false;
  try {
    return session.getItem(OFFER_DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

// Remember a dismissal for the session (resets on a new tab/session).
function markDismissed(session = offerSession()) {
  if (!session) return;
  try { session.setItem(OFFER_DISMISS_KEY, "1"); } catch { /* private mode — won't persist */ }
}

// Per-popup conversion marker for the storefront popup widget (card 89). When a
// visitor WINS/CLAIMS a popup's offer (plinko win, quiz coded complete, a coded
// button, a navigate-out completion), that popup's lifecycle for this browser is
// OVER: we persist a "converted" marker so eligibility excludes it on every
// subsequent page, regardless of the popup's frequency config. Mirrors
// offer-store.js: an injectable storage (defaults to the window global), every
// access try/catch-wrapped so a blocked/absent storage never throws, JSON.parse
// guarded, pure + node-testable. Uniquely-named helpers (convertedStorage /
// isConvertedMap) so the popup bundle's function-dedup build stays green.
//
// Durable map in localStorage under `szn_popup_converted`:
//   { [popupId]: ts }   (ts = ms epoch, drives the TTL)
// with a 30-day TTL — a conversion suppresses re-arming for a month, then a stale
// id self-clears rather than tagging the browser forever.

const CONVERTED_KEY = "szn_popup_converted";

// 30 days. A won/claimed popup stays suppressed for a month, then self-clears.
const CONVERTED_TTL_MS = 30 * 24 * 60 * 60 * 1000;

function convertedStorage() {
  try {
    if (typeof localStorage !== "undefined") return localStorage;
  } catch { /* access can throw in sandboxed frames */ }
  return null;
}

function isConvertedMap(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}

// Read the whole converted map, dropping any entries older than the TTL. Returns
// { map, changed }: the pruned map plus whether pruning removed anything (so the
// caller can persist the pruned map). Returns an empty map on any failure.
function readMap(storage, now) {
  if (!storage) return { map: {}, changed: false };
  let raw;
  try {
    raw = storage.getItem(CONVERTED_KEY);
  } catch {
    return { map: {}, changed: false };
  }
  if (!raw) return { map: {}, changed: false };
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    clearConverted(storage);
    return { map: {}, changed: false };
  }
  if (!isConvertedMap(parsed)) {
    clearConverted(storage);
    return { map: {}, changed: false };
  }
  const at = typeof now === "number" ? now : Date.now();
  const map = {};
  let changed = false;
  for (const id of Object.keys(parsed)) {
    const ts = parsed[id];
    if (typeof ts === "number" && at - ts <= CONVERTED_TTL_MS) {
      map[id] = ts;
    } else {
      changed = true; // stale or malformed entry pruned
    }
  }
  return { map, changed };
}

// Persist the whole map. Swallows quota/blocked errors.
function writeMap(map, storage) {
  if (!storage) return;
  try {
    storage.setItem(CONVERTED_KEY, JSON.stringify(map));
  } catch { /* quota / private mode — marker just won't persist */ }
}

// Has this popup been converted (won/claimed) in this browser, within the TTL?
// Self-clears stale entries encountered on read.
function isConverted(id, storage = convertedStorage(), now = Date.now()) {
  if (typeof id !== "string" || !id) return false;
  const { map, changed } = readMap(storage, now);
  if (changed) writeMap(map, storage);
  return Object.prototype.hasOwnProperty.call(map, id);
}

// Mark this popup as converted at `now` (ms epoch). Idempotent per id; prunes any
// stale ids in the same write. No-ops on a missing id/storage.
function markConverted(id, now = Date.now(), storage = convertedStorage()) {
  if (typeof id !== "string" || !id || !storage) return;
  const at = typeof now === "number" ? now : Date.now();
  const { map } = readMap(storage, at);
  map[id] = at;
  writeMap(map, storage);
}

// Remove every converted marker (QA / reset). Swallows any error.
function clearConverted(storage = convertedStorage()) {
  if (!storage) return;
  try { storage.removeItem(CONVERTED_KEY); } catch { /* ignore */ }
}

// Top offer banner for the storefront popup widget (card 51). A slim, sticky,
// full-width bar that re-surfaces an offer the visitor already earned (see
// offer-store.js) on every subsequent page load, so the outcome follows them to the
// PDP. PURE DOM builder: the document is injected (like the render-popup helpers) so
// it builds under `node --test` with the tiny fake DOM.
//
// SECURITY BOUNDARY: `code` / `discount` / `banner` originate from the model doc and
// the origin-verified embed message, but are still treated as untrusted at render
// time. ALL text is set via textContent (never innerHTML); no attribute-injected
// URLs. Nothing here executes model strings.


// Just BELOW the popup overlay (2147483000) but ABOVE a typical theme announcement
// bar, so the earned offer sits at the absolute top of the page.
const BANNER_Z = 2147482000;

// Resolve the banner copy for an offer. Model-driven: prefer the stored `banner`
// template (marketer-authored, fills `{discount}` / `{code}` placeholders), else a
// default. Discount label is the `discount` value when present, otherwise the code
// itself. Wording uses a " - " hyphen (no em dashes, per SZN copy rules).
function bannerText(offer) {
  const o = offer && typeof offer === "object" ? offer : {};
  const code = typeof o.code === "string" ? o.code : "";
  const label = o.discount != null && o.discount !== "" ? String(o.discount) : code;
  if (typeof o.banner === "string" && o.banner) {
    return o.banner
      .replace(/\{discount\}/g, label)
      .replace(/\{code\}/g, code);
  }
  return label + " applied - shows at checkout";
}

// Build the banner node. `doc` is injected; `onDismiss` fires when the × is clicked.
// A slim fixed full-width bar, brand-dark background, white text, inherits the store
// font. Returns the bar node (caller mounts it). All copy via textContent.
function buildOfferBanner(doc, offer, onDismiss) {
  const bar = doc.createElement("div");
  bar.setAttribute("role", "status");
  bar.setAttribute("aria-live", "polite");
  bar.setAttribute("data-szn-offer-banner", "1");
  const s = bar.style;
  s.position = "fixed";
  s.top = "0";
  s.left = "0";
  s.right = "0";
  s.zIndex = String(BANNER_Z);
  s.display = "flex";
  s.alignItems = "center";
  s.justifyContent = "center";
  s.gap = "12px";
  s.padding = "8px 16px";
  s.background = "#12100e";
  s.color = "#ffffff";
  s.font = "inherit";
  s.fontSize = "14px";
  s.lineHeight = "1.3";
  s.textAlign = "center";

  const msg = doc.createElement("span");
  msg.textContent = bannerText(offer);
  bar.appendChild(msg);

  const close = doc.createElement("button");
  close.setAttribute("type", "button");
  close.setAttribute("aria-label", "Dismiss offer");
  close.textContent = "×"; // × as text, not markup
  const cs = close.style;
  cs.background = "transparent";
  cs.border = "0";
  cs.color = "inherit";
  cs.font = "inherit";
  cs.fontSize = "18px";
  cs.lineHeight = "1";
  cs.cursor = "pointer";
  cs.padding = "0 4px";
  close.addEventListener("click", () => { if (typeof onDismiss === "function") onDismiss(); });
  bar.appendChild(close);

  return bar;
}

// Browser glue: skip if there's no offer or the banner was dismissed this session;
// otherwise build the bar, prepend it to <body>, and wire dismiss → markDismissed +
// remove. Returns the mounted node, or null when nothing was rendered.
function mountOfferBanner(doc, offer, session) {
  if (!doc || !offer || !offer.code) return null;
  if (isDismissed(session)) return null;
  const body = doc.body;
  if (!body) return null;
  const bar = buildOfferBanner(doc, offer, () => {
    markDismissed(session);
    if (typeof bar.remove === "function") bar.remove();
    else if (bar.parentNode && typeof bar.parentNode.removeChild === "function") bar.parentNode.removeChild(bar);
  });
  if (typeof body.prepend === "function") body.prepend(bar);
  else body.appendChild(bar);
  return bar;
}

// Orchestrator for the storefront popup widget (card 41). Fetches enabled popups
// from the model API (CORS GET, base configurable via window.SZN_POPUP_API with a
// default), then per popup runs the pipeline:
//   eligibility (targeting + frequency) → pickVariant → scheduleTrigger → on fire:
//   render the resolved popup, record the show, report exposure + popup_opened, and
//   wire conversion reporting (engaged / email / offer / closed).
// NOTHING is hard-coded about a specific popup — the widget renders whatever the
// model says. Every dependency (fetch/storage/posthog/render/hooks) is injectable so
// the whole pipeline runs under `node --test` with no DOM.









// Default API base: the Vercel quiz-funnel origin (CORS is open on api/popups.js).
// Overridable via window.SZN_POPUP_API so a preview host can point elsewhere.
const DEFAULT_API_BASE = "https://quiz.sznpouches.com";

function apiBase(env) {
  const fromWin = env && env.apiBase;
  if (typeof fromWin === "string" && fromWin) return fromWin.replace(/\/+$/, "");
  return DEFAULT_API_BASE;
}

// Fetch the enabled popups list. Returns [] on any failure (never throws).
async function fetchPopups(env) {
  const fetchFn = env.fetch;
  if (typeof fetchFn !== "function") return [];
  try {
    const res = await fetchFn(apiBase(env) + "/api/popups");
    if (!res || !res.ok) return [];
    const body = await res.json();
    return Array.isArray(body && body.popups) ? body.popups : [];
  } catch {
    return [];
  }
}

// Fetch a SINGLE popup document by id via the preview endpoint (preview=1, so a
// draft is returned too). Returns the raw row or null on any failure (never
// throws) — used only by preview mode. `req` is a parsed preview request
// { id, variantKey? }; the variant is resolved client-side, but we pass it so the
// server can pre-merge (both are equivalent, resolvePopupVariant re-applies).
async function fetchOnePopup(env, req) {
  const fetchFn = env.fetch;
  if (typeof fetchFn !== "function" || !req || !req.id) return null;
  try {
    const url = previewApiUrl(apiBase(env), req.id, null);
    const res = await fetchFn(url);
    if (!res || !res.ok) return null;
    const body = await res.json();
    // get-one returns the row shape { id, config, variants, ... } directly.
    return isObject(body) ? body : null;
  } catch {
    return null;
  }
}

function isObject(v) {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}

function primaryButton(popup) {
  const elements = Array.isArray(popup && popup.elements) ? popup.elements : [];
  return elements.find((el) => el && el.kind === "button" && isObject(el.props)) || null;
}

// Assemble the stored offer object from the popup doc + earned code/discount. Reads
// the OPTIONAL, model-driven `popup.content.offer_banner` template (req #4) defensively
// so an absent field just falls back to the default banner copy downstream.
function offerFromPopup(popup, code, discount) {
  const content = popup && isObject(popup.content) ? popup.content : {};
  return {
    popupId: (popup && popup.id) || null,
    code: code || null,
    discount: discount != null ? discount : null,
    banner: typeof content.offer_banner === "string" ? content.offer_banner : null,
  };
}

// Persist an earned offer via the injected hook, only when a code is present and the
// hook is wired. Optional by design: preview/tests stay pure and the NO-OFFER paths
// are byte-identical when no code exists.
function persistOffer(env, popup, code, discount) {
  if (!code || typeof env.saveOffer !== "function") return;
  env.saveOffer(offerFromPopup(popup, code, discount));
}

// Mark this popup CONVERTED (won/claimed) via the injected hook so it is excluded
// from eligibility on every subsequent page (card 89). Called at each genuine
// win/claim conversion — NOT on a plain close. Optional by design: absent the hook
// (preview/tests that don't inject it) this is a silent no-op.
function persistConverted(env, popup) {
  const id = popup && popup.id;
  if (typeof id !== "string" || typeof env.markConverted !== "function") return;
  env.markConverted(id);
}

function resolveDiscountNavigation(code, redirectUrl, env) {
  if (!code) return redirectUrl || null;
  if (redirectUrl && typeof env.discountUrl === "function") {
    const url = env.discountUrl(code, redirectUrl || null);
    if (url) return url;
  }
  if (typeof env.onDiscount === "function") env.onDiscount(code);
  return redirectUrl || null;
}

// api/popups.js returns DB rows as { id, config, variants, posthogFlagKey, ... }.
// The renderer/eligibility pipeline consumes the effective popup document, so flatten
// the row once at the boundary while preserving already-flat test/preview docs.
function normalizePopupDoc(row) {
  if (!isObject(row)) return {};
  const config = isObject(row.config) ? row.config : {};
  return {
    ...config,
    id: typeof row.id === "string" ? row.id : config.id,
    name: row.name || config.name,
    type: row.type || config.type,
    enabled: row.enabled,
    variants: Array.isArray(row.variants) ? row.variants : (Array.isArray(config.variants) ? config.variants : []),
    posthogFlagKey: row.posthogFlagKey || row.posthog_flag_key || config.posthogFlagKey || null,
    updated_at: row.updated_at,
  };
}

// Resolve a CTA descriptor from the canonical source order (card 73):
//   1. a button element that resolves to a NAVIGATE — an authored CTA button with a
//      real destination OVERRIDES the model destination.
//   2. otherwise the popup's model-level `config.destination` (resolveDestination) —
//      so a win/click with no button (or a button with no href) still has a home.
//   3. otherwise the button's own descriptor (typically a close), else a safe close.
// A `null`/non-navigating earlier source falls through, so an absent/shapeless
// destination never dead-ends the CTA. Returns a descriptor ({navigate|close, code}).
function resolvePopupCta(destination, buttonProps, config) {
  const fromButton = buttonProps ? resolveCta(buttonProps, config) : null;
  if (fromButton && fromButton.kind === "navigate") return fromButton;
  const fromDestination = resolveDestination(destination, config);
  if (fromDestination) return fromDestination;
  if (fromButton) return fromButton;
  return resolveCta({}, config);
}

// Wire the element callbacks a rendered popup calls back through, translating them
// into conversion reports + CTA side effects. `env.navigate(url)` performs a nav
// (injected; defaults to location assignment in bootstrap).
function makeCallbacks(popup, reporter, env, controllerRef) {
  const cfg = (env.config) || {};
  const destination = popup && isObject(popup.destination) ? popup.destination : null;
  function closeForNavigate() {
    if (controllerRef.controller) controllerRef.controller.close("cta");
  }
  return {
    config: cfg,
    window: env.window,
    onClose: () => reporter.conversion("closed"),
    onButton(el) {
      reporter.conversion("engaged", { element_id: el && el.id });
      const desc = resolvePopupCta(destination, (el && el.props) || null, cfg);
      if (desc.kind === "navigate") {
        reporter.conversion("offer", { code: desc.code || null });
        persistOffer(env, popup, desc.code, desc.discount);
        persistConverted(env, popup); // navigate-out CTA ends this popup's lifecycle
        const url = resolveDiscountNavigation(desc.code, desc.url, env);
        closeForNavigate(); // run close lifecycle before navigation so launcher state restores
        if (url && typeof env.navigate === "function") env.navigate(url);
      } else {
        if (desc.code) reporter.conversion("offer", { code: desc.code });
        persistOffer(env, popup, desc.code, desc.discount);
        if (desc.code) persistConverted(env, popup); // coded claim converts; plain close does not
        resolveDiscountNavigation(desc.code, null, env);
        if (controllerRef.controller) controllerRef.controller.close("cta");
      }
    },
    onEmail(value, el) {
      reporter.conversion("email", { element_id: el && el.id });
      if (typeof env.onEmail === "function") env.onEmail(value, popup);
    },
    onEmbed(action) {
      if (!action) return;
      if (action.kind === "win") {
        // Canonical CTA source: destination first, button element as override
        // (card 73). A win with a configured destination but NO button now
        // navigates (fixes the plinko CLAIM dead-end); a win with NEITHER a
        // navigate destination nor a button stays OPEN on the success panel —
        // never a silent close.
        const button = primaryButton(popup);
        const desc = resolvePopupCta(destination, button ? (button.props || {}) : null, cfg);
        const code = action.code || desc.code;
        const discount = action.discount != null ? action.discount : desc.discount;
        reporter.conversion("offer", { code: code || null, discount });
        persistOffer(env, popup, code, discount);
        persistConverted(env, popup); // a win ends this popup's lifecycle
        const url = desc.kind === "navigate"
          ? resolveDiscountNavigation(code, desc.url, env)
          : resolveDiscountNavigation(code, null, env);
        if (url) closeForNavigate(); // navigate-out win dismisses via the popup close lifecycle
        if (url && typeof env.navigate === "function") env.navigate(url);
        // else: no destination → leave the popup OPEN (do NOT close on success).
      } else if (action.kind === "navigate") {
        // The funnel asked the top window to navigate (checkout/CTA handoff, card
        // 73). Route through the discount chain when the destination configures a
        // code; the url is already origin/scheme-checked by handleEmbedMessage.
        const dcode = destination && typeof destination.discount_code === "string"
          ? destination.discount_code : null;
        const url = resolveDiscountNavigation(dcode, action.url, env);
        persistConverted(env, popup); // navigate-out completion ends the lifecycle
        closeForNavigate(); // restore popup-owned page state before top-window navigation
        if (url && typeof env.navigate === "function") env.navigate(url);
      } else if (action.kind === "complete") {
        // Codeless quiz completion (plan pricing, no code): log the conversion and
        // KEEP the popup open on the result panel. Never a silent close (card 73).
        reporter.conversion("offer", { code: null });
        persistConverted(env, popup); // quiz completed → lifecycle over
      } else if (action.kind === "close") {
        if (controllerRef.controller) controllerRef.controller.close("embed");
      } else if (action.kind === "engaged") {
        // Quiz embed engagement (first answer) — same conversion the button path logs.
        reporter.conversion("engaged", { source: "embed" });
      } else if (action.kind === "step") {
        // Quiz step broadcast (card 113): widen the popup for the result step, revert on
        // any earlier step (incl. Back). Display-only — no conversion is logged here.
        const controller = controllerRef.controller;
        if (controller && typeof controller.setResultWide === "function") {
          controller.setResultWide(action.stepType === "result");
        }
      }
    },
  };
}

// Run one popup through the pipeline. Returns the trigger handle (or null if it
// never scheduled). `env.render(doc, resolved, callbacks)` builds the shell and
// returns a controller { open, close }; injected so tests don't need a DOM.
function runPopup(rawPopup, env) {
  const popup = normalizePopupDoc(rawPopup);
  if (typeof popup.id !== "string") return null;
  const now = (env.now || Date.now)();
  const baseRecord = env.eligibilityRecord
    ? env.eligibilityRecord(popup.id)
    : eligibilityRecord(popup.id, env.storage, env.session);
  // Merge the CONVERTED flag (card 89) so a won/claimed popup is excluded from
  // eligibility regardless of targeting/frequency. Injectable; defaults to no-op
  // (false) when no hook is wired, so tests that inject their own env are unaffected.
  const converted = typeof env.isConverted === "function"
    ? env.isConverted(popup.id) === true
    : false;
  const record = { ...baseRecord, converted };

  if (!isEligible(popup, env.ctx || {}, record, now)) return null;

  const { variantKey, resolved } = pickVariant(popup, env.flagReader);
  const withId = { ...resolved, id: popup.id, posthogFlagKey: popup.posthogFlagKey };
  const reporter = makeReporter(withId, variantKey, env.capture);

  const controllerRef = { controller: null };
  const fire = () => {
    const callbacks = makeCallbacks(withId, reporter, env, controllerRef);
    const controller = env.render(env.document, withId, callbacks);
    controllerRef.controller = controller;
    if (controller && typeof controller.open === "function") controller.open();
    const stamp = (env.now || Date.now)();
    if (env.recordShow) env.recordShow(popup.id, stamp);
    else recordShow(popup.id, stamp, env.storage, env.session);
    reporter.exposure();
    reporter.conversion("opened");
  };

  const trigger = (popup && popup.trigger) || {};
  return scheduleTrigger(trigger.kind, trigger.params || {}, env.hooks || {}, fire);
}

// Fetch + run every popup. Returns the array of trigger handles (for teardown/tests).
async function runWidget(env) {
  const popups = await fetchPopups(env);
  const handles = [];
  for (const rawPopup of popups) {
    const handle = runPopup(rawPopup, env);
    if (handle) handles.push(handle);
  }
  return handles;
}

// A reporter whose every call is a no-op. Preview mode wires this instead of the
// real reporter so NO analytics fire — no $feature_flag_called, no popup_opened,
// no conversion events from element callbacks (engaged/email/offer/closed).
const NULL_REPORTER = { exposure() {}, conversion() {} };

// PREVIEW MODE (card 50): force-show one popup by id, bypassing
// eligibility/trigger/frequency and firing zero analytics. Detects the preview
// request off `env.previewSearch` (location.search in the browser), fetches the
// popup by id INCLUDING drafts, chooses the variant (explicit key, else first
// variant, else base), renders immediately with the no-op reporter, and records
// nothing. Returns the render controller (or null if there was no valid preview
// request / the fetch failed). Normal mode is completely untouched.
async function runPreview(env) {
  const req = parsePreviewRequest(env && env.previewSearch);
  if (!req) return null;
  const raw = await fetchOnePopup(env, req);
  if (!raw) return null;
  const popup = normalizePopupDoc(raw);
  if (typeof popup.id !== "string") return null;

  const { variantKey, resolved } = choosePreviewVariant(popup, req.variantKey);
  const withId = { ...resolved, id: popup.id, posthogFlagKey: popup.posthogFlagKey };

  const controllerRef = { controller: null };
  const callbacks = makeCallbacks(withId, NULL_REPORTER, env, controllerRef);
  const controller = env.render(env.document, withId, callbacks);
  controllerRef.controller = controller;
  if (controller && typeof controller.open === "function") controller.open();
  // Deliberately: no recordShow, no reporter.exposure(), no reporter.conversion().
  void variantKey;
  return controller;
}

// Browser entry for the storefront popup widget (card 41). Wires the REAL globals
// (fetch, localStorage/sessionStorage, PostHog, the DOM trigger hooks, and the
// render layer) into the pure orchestrator (widget.js) and bootstraps itself on
// page load. This is the only file that reads window/document directly; the pure
// pipeline stays injectable + unit-testable. Not imported by tests.







// Detect the current page bucket from the URL for targeting `pages`. Best-effort:
// maps common Shopify paths to the registry page values.
function detectPage() {
  const p = (location.pathname || "").toLowerCase();
  if (p === "/" || p === "") return "home";
  if (p.startsWith("/products")) return "product";
  if (p.startsWith("/collections")) return "collection";
  if (p.startsWith("/cart")) return "cart";
  if (p.startsWith("/checkout")) return "checkout";
  return "home";
}

function detectDevice() {
  const w = window.innerWidth || 1024;
  if (w < 768) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

// Ad vs organic from the URL (utm_source / gclid / fbclid present → ad).
function detectSource() {
  const q = new URLSearchParams(location.search || "");
  if (q.get("gclid") || q.get("fbclid") || q.get("utm_source")) return "ad";
  const ref = document.referrer || "";
  if (/mail|klaviyo/.test(ref)) return "email";
  if (/facebook|instagram|tiktok|twitter|t\.co/.test(ref)) return "social";
  return "organic";
}

// Returning vs new from localStorage stamp.
function detectAudience() {
  try {
    const seen = localStorage.getItem("szn_popup_returning");
    localStorage.setItem("szn_popup_returning", "1");
    return seen ? "returning" : "new";
  } catch {
    return "new";
  }
}

// DOM trigger hooks for scheduleTrigger. Counting delay from the load event, wiring
// scroll depth + top mouseleave exit-intent. Each register returns an unbind fn.
function domHooks() {
  return {
    onLoad(cb) {
      if (document.readyState === "complete") { cb(); return () => {}; }
      const h = () => cb();
      window.addEventListener("load", h, { once: true });
      return () => window.removeEventListener("load", h);
    },
    setTimeout: (cb, ms) => window.setTimeout(cb, ms),
    clearTimeout: (t) => window.clearTimeout(t),
    addScroll(cb) {
      const h = () => cb();
      window.addEventListener("scroll", h, { passive: true });
      return () => window.removeEventListener("scroll", h);
    },
    addScrollIntent(cb) {
      const h = () => cb();
      const events = ["scroll", "wheel", "touchmove"];
      for (const ev of events) window.addEventListener(ev, h, { passive: true });
      return () => { for (const ev of events) window.removeEventListener(ev, h); };
    },
    scrollPercent() {
      const doc = document.documentElement;
      const max = (doc.scrollHeight - doc.clientHeight) || 1;
      return Math.min(100, Math.round((window.scrollY / max) * 100));
    },
    addExit(cb) {
      const h = (e) => { if (e.clientY <= 0) cb(); };
      document.addEventListener("mouseleave", h);
      return () => document.removeEventListener("mouseleave", h);
    },
  };
}

// PostHog flag reader (assigned variant string), gated behind onFeatureFlags so a
// flag that loads async isn't read as unresolved. No-op safe.
function flagReader(flagKey) {
  try {
    if (window.posthog && typeof window.posthog.getFeatureFlag === "function") {
      return window.posthog.getFeatureFlag(flagKey);
    }
  } catch { /* ignore */ }
  return undefined;
}

function buildEnv() {
  return {
    fetch: window.fetch ? window.fetch.bind(window) : null,
    apiBase: window.SZN_POPUP_API,
    previewSearch: (location && location.search) || "",
    document,
    window,
    storage: safeStorage("localStorage"),
    session: safeStorage("sessionStorage"),
    capture: window.posthog && window.posthog.capture
      ? window.posthog.capture.bind(window.posthog) : null,
    flagReader,
    hooks: domHooks(),
    render: (doc, resolved, callbacks) => buildPopup(doc, resolved, callbacks),
    navigate: (url) => { try { window.location.assign(url); } catch { /* ignore */ } },
    discountUrl,
    onDiscount: applyDiscount,
    saveOffer: (offer) => saveOffer(offer, safeStorage("localStorage")),
    isConverted: (id) => isConverted(id, safeStorage("localStorage")),
    markConverted: (id) => markConverted(id, Date.now(), safeStorage("localStorage")),
    config: (window.SZN_POPUP_CONFIG) || {},
    ctx: {
      page: detectPage(),
      device: detectDevice(),
      source: detectSource(),
      audience: detectAudience(),
    },
  };
}

function safeStorage(name) {
  try { return window[name]; } catch { return null; }
}

function safeDiscountCode(code) {
  return typeof code === "string" && /^[A-Za-z0-9_-]{1,80}$/.test(code) ? code : null;
}

function redirectPath(url) {
  if (typeof url !== "string" || !url) return "/cart";
  if (url.startsWith("/") && !url.startsWith("//")) return url;
  try {
    const u = new URL(url, window.location.origin);
    if (u.origin === window.location.origin) return u.pathname + u.search + u.hash;
  } catch { /* ignore */ }
  return "/cart";
}

function discountUrl(code, redirectUrl) {
  const safeCode = safeDiscountCode(code);
  if (!safeCode) return null;
  return "/discount/" + encodeURIComponent(safeCode)
    + "?redirect=" + encodeURIComponent(redirectPath(redirectUrl));
}

function applyDiscount(code) {
  const url = discountUrl(code, "/cart");
  if (!url) return;
  try {
    const frame = document.createElement("iframe");
    frame.setAttribute("aria-hidden", "true");
    frame.style.position = "absolute";
    frame.style.width = "1px";
    frame.style.height = "1px";
    frame.style.opacity = "0";
    frame.style.pointerEvents = "none";
    frame.setAttribute("src", url);
    document.body && document.body.appendChild(frame);
    window.setTimeout(() => { try { frame.remove(); } catch { /* ignore */ } }, 5000);
  } catch { /* discount application must not block popup flow */ }
}

// Bootstrap once the flags have loaded (or immediately if PostHog isn't present).
// PREVIEW MODE short-circuits everything: when the URL carries a valid
// `szn-popup-preview=<id>`, force-show that popup immediately with analytics
// suppressed (capture: null) and NO PostHog flag gate, then stop. Absent the
// param, the normal path below is byte-for-byte unchanged.
function start() {
  const env = buildEnv();
  if (parsePreviewRequest(env.previewSearch)) {
    runPreview({ ...env, capture: null }).catch(() => {});
    return;
  }
  // Re-surface a previously earned, unexpired, un-dismissed offer at the top of the
  // page on every load, BEFORE (and independent of) the popup fetch. No offer =>
  // nothing appended. Never in preview mode (short-circuited above).
  try {
    const offer = readOffer(safeStorage("localStorage"));
    if (offer) mountOfferBanner(document, offer, safeStorage("sessionStorage"));
  } catch { /* banner must never block the widget */ }
  const go = () => { runWidget(env).catch(() => {}); };
  try {
    if (window.posthog && typeof window.posthog.onFeatureFlags === "function") {
      let started = false;
      const once = () => { if (started) return; started = true; go(); };
      window.posthog.onFeatureFlags(once);
      window.setTimeout(once, 2500); // fail-open if flags never resolve
    } else {
      go();
    }
  } catch {
    go();
  }
}

if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
}

})();
